import {wizardActionTypes as ActionTypes} from "../constants";
import { put, select, takeEvery, takeLatest, call, all, delay } from 'redux-saga/effects';
import html2canvas from "html2canvas";
import QRCode from "qrcode";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import {showSnackbar} from '../utils/snackbar';
import {setPageDetails, getPages, setPageData, getPlanOverViewData, 
        setDrawingData,uploadExportDrawing, getImagesBasedOnTag,
        resetZoom,imageData,setRoomImages,textSelected, saveCropSelectionDetails } from "../actions/wizard";
import template from '../templates.json';
import instructionsTempleates  from '../instructions.js';
import wizardClient from "../helpers/wizardClient";
import {sidebarInfo} from '../constants/sidebar.js';
import {roomNotes} from '../constants/roomNotes.js';
import { addPDFLinks, addPageNotes } from "helpers/helper";
import { cloneDeep } from "lodash";
import {fabric} from 'fabric';
import { pdfLinks } from "./pdfLinks";
import { CustomerFalseCeilingTypes, HDSPageSeparation } from '../containers/pages/CustomFalseCeilingPage/CustomFalseCeilingConstants';
import { dynamic_curve } from '../utils/dynamic_curve';
import { getPdfPagesAsImages, isPdfUrl } from '../utils/pdfUtils';
import { DisplayPayloadExtractor } from '../utils/displayPayloadExtractor';
import { isBrigadeProfile, getSpacecraftDrawingUrl, getSpacecraftUrl, stripBrigadeSegment } from '../utils/profile';

let pageindex = 0;
// const maxRowsLightPlanList = 10;
const maxRowsHandleTable = 3;
const maxCounterTopTables =2;
const maxFalseCeilingPlanImages = 4
const maxFalseCeilingOverviewLights = 15
const maxFalseCeilingSectionImages = 1
const maxFalseCeilingReflectedLights = 8
let _clipboard=[];
let disconnected=false;

// const doc = new jsPDF({
//     orientation: 'a4',
//     unit: 'mm',
//     format: [297, 210]
// })

const wizardSelector = state => state.wizard.pages;
const previewModeSelector = state => state.wizard.previewMode;
const fabricInstanceSelector = state => state.wizard.fabricInstance;
const pageDetailsSelector = state => state.wizard.pageDetails;
//const screenSizeSelector = state => state.wizard.screenSize;
//const drawingObjectSelector = state => state.wizard.drawingObject;
//const scaleFactorSelector = state => state.wizard.scaleFactor;
const project = state => state.wizard.projectData;
const accessToken =()=> localStorage.getItem('access_token');
const pageDetails = state => state.wizard.pageDetails;
const isDqcDataPresent = state => state.wizard.isDqcDataPresent;
const selectedObjects = state => state.wizard.selectedObjects;
const orderProfileSelector = state => state.wizard.orderProfileType; 
const floorsDataSelector = state => state.wizard.floorsData;
const exportDrawingStatusSelector = state => state.wizard.exportDrawingStatus;
const selectedCropImageDetailsSelector = state => state.wizard.selectedCropImageDetails;
const textFormattingSelector = state => state.wizard.paintFormatting;
const uploadImageSelector = state => state.wizard.uploadingImage;
let splitted_modules={};
let categoriesS3Url = {};


/*function addWaterMark (){
    try {
         const totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.setTextColor(150);
            doc.setFontSize(50);
            doc.text(50, doc.internal.pageSize.height - 150, 'PREVIEW ONLY');
        }

    }
    catch(e) {
        throw e
    }

}*/

// function createElevationViews(elevationId, elevationViewName, roomType){
//     try {
//         let elePage = {};
//         elePage['elevation1'] = Object.assign({},template['pages'][roomType]['elevation1']);
//         elePage['elevation1']['elevationId'] = elevationId;
//         elePage['elevation1']['name'] = `Elevation ${elevationViewName} - Dimension`;
//         elePage['elevation2'] = Object.assign({},template['pages'][roomType]['elevation2']);
//         elePage['elevation2']['elevationId'] = elevationId;
//         elePage['elevation2']['name'] = `Elevation ${elevationViewName} - Material`;
//         elePage['elevation3'] = Object.assign({},template['pages'][roomType]['elevation3']);
//         elePage['elevation3']['elevationId'] = elevationId;
//         elePage['elevation3']['name'] = `Elevation ${elevationViewName} - Internal`;
//         return elePage;
//     } catch (error) {
//         throw error;
//     }
// }

function setPageTemplates(view, temp){
    try {
        Object.keys(view).map(viewKey =>{
            if(temp.hasOwnProperty(viewKey)){
                temp[viewKey] = view[viewKey];
            }
            return viewKey;
        });
        return temp;
    } catch (error) {
        console.error("Error in setPageTemplates",error);
    }
}

function mapTemplateKeys(template, keys, updatedObj, key){
    try {
        (keys || []).map(respKey=>{
            if(respKey){
                if(template['carcaseDetails'][key] && template['carcaseDetails'][key][respKey]){
                    template['carcaseDetails'][key][respKey]['value'] = updatedObj[respKey].toString();
                }
            }
            return respKey;
        });
        const tempObj = Object.assign({}, template);
        return tempObj;
    } catch (error) {
        console.error("Error in mapTemplateKeys");
    }
}

const SESSION_EXPIRED_MESSAGE = "Your session has expired. Please launch this app from SC again.";

function* fetchDrawingApi(path, options: any = {}){
    let token = yield select(accessToken);
    if(!token){
        showSnackbar(SESSION_EXPIRED_MESSAGE, 5000);
    }
    let headers = Object.assign({}, options.headers, { "Authorization": `Bearer ${token}` });
    let response = yield fetch(`${process.env.REACT_APP_DRAWING_API_URL}${path}`, Object.assign({}, options, { headers }));
    if(response && response.status === 401){
        showSnackbar(SESSION_EXPIRED_MESSAGE, 5000);
    }
    return response;
}

function* getProjectDetails({data}){
    try {
        let {projectId} = data;
        if(!projectId)
            return;
        
        // const result = yield wizardClient.get(
        //     `pages/project/${projectId}/room/${roomId}`,
        //     {
        //         data: {[pageDetails.pageNumber]:pageDetails}, // add updated zone data here
        //     }
        //
        let projectData = yield fetch(`${getSpacecraftDrawingUrl()}projects/${projectId}`,{
            headers:{
                "Authorization": yield select(accessToken)
            }
        });

        // Todo: For DC added a Hack to fetch SC OrderProfileType
        let scProjectData = yield fetch(`${getSpacecraftUrl()}api/v1.0/project/${projectId}`,{
            headers:{
                "Authorization": yield select(accessToken)
            }
        });
        scProjectData = yield scProjectData.json();


        // document.body.style.zoom = "100%";
        projectData = yield projectData.json();
        let dqcData = yield fetch(`${getSpacecraftDrawingUrl()}projects/${projectId}/dqcdata`);
        let dqcData_json = yield dqcData.json();
        let {customerId, customerName, designerEmail, designerName, projectManagerEmail, projectManagerName, roomBasicInfoList, displayProfile} = projectData;
        // Todo: For DC added a Hack to fetch SC OrderProfileType
        const dcOrderProfileType = ['dc', 'designcafe']?.includes(scProjectData?.customer?.orderProfile?.toLowerCase())        
        const orderData = yield fetch(`${ dcOrderProfileType ? process.env.REACT_APP_ROSTER_DC_API_URL : process.env.REACT_APP_ROSTER_API_URL}${new URLSearchParams({customerid:customerId})}`, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${dcOrderProfileType ? localStorage.getItem('roster_dc_token') : localStorage.getItem('roster_token')}`,
              source: 'spacecraft'
            }
          })
        const orderDataJson = yield orderData.json();
        let orderProfileType="HOMELANE";
        let orderProfileTitle = "HomeLane";
        if(orderDataJson && orderDataJson.response){
            orderProfileType = orderDataJson['response'][0]['orderProfileType']? orderDataJson['response'][0]['orderProfileType'].toUpperCase() : "HOMELANE";
        }

        // Todo: For DC added a Hack to fetch SC OrderProfileType
        if(scProjectData?.customer?.orderProfile?.toLowerCase() === 'dc' || scProjectData?.customer?.orderProfile?.toLowerCase() === "designcafe") {
            orderProfileType = 'DC';
        }

        if(['dc', 'designcafe'].includes(orderProfileType?.toLowerCase()) || ['dc', 'designcafe'].includes(scProjectData?.customer?.orderProfile?.toLowerCase())) {
            document.documentElement.setAttribute('data-role', "DC");
            const link: any = document.querySelector("link[rel~='icon']") || document.createElement("link");

            link.rel = "icon";
            link.href = "https://d18w0now3310fo.cloudfront.net/assets/lead-deck-dc/design-cafe-logo_gem.png";
            document.getElementsByTagName("head")[0].appendChild(link);
            orderProfileTitle = "DesignCafe";
        }

        // Brigade has no server-side profile signal - it's identified purely from the app URL.
        if(isBrigadeProfile()) {
            orderProfileType = 'BRIGADE';
            orderProfileTitle = "Brigade";
            document.documentElement.setAttribute('data-role', "BRIGADE");
            const brigadeLink: any = document.querySelector("link[rel~='icon']") || document.createElement("link");

            brigadeLink.rel = "icon";
            brigadeLink.href = "https://d18w0now3310fo.cloudfront.net/assets/misc/brigade-logo.ico";
            document.getElementsByTagName("head")[0].appendChild(brigadeLink);
        }
        yield put({type:ActionTypes.ORDER_PROFILE_TYPE,data:orderProfileType});
        yield put({type:ActionTypes.ORDER_PROFILE_TITTLE,data:orderProfileTitle});
        const currentDate = new Date();
        let date = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth()+1).padStart(2, '0')}-${currentDate.getFullYear()}`;
        projectData = {
            opportunityId: projectId,
            published_data:"",
            version: "1",
            customer_details:{
                "Customer_Name": customerName,
                "Customer_Type": "SC Pro",
                "Client_Id": customerId,
                // "Project_Id": customerId,
                "Lead_Designer":{
                    "name":designerName,
                    "emailId": designerEmail
                }, 
                "DQC_Manager":{
                    "name":dqcData_json?.name,
                    "emailId":dqcData_json?.emailId
                },
                "Project_Manager": {
                    "name": projectManagerName ? projectManagerName: "Captain",
                    "emailId": projectManagerEmail
                },
                "Date": date+" (DD-MM-YYYY)",
                displayProfile: displayProfile
            },
            roomDetails:{

            },
        }

        let isDqcDataPresent = projectData.customer_details.DQC_Manager.emailId===null?false:true;
        let url = window.location.href;
        let roomSplit = stripBrigadeSegment(url.split('/'));
        let roomId = roomSplit[roomSplit.length-1], roomName = '',roomType='';
        if(projectId === roomId){
            roomId = roomBasicInfoList[0].roomId;
            roomName = roomBasicInfoList[0].roomName;
            roomType = roomBasicInfoList[0].roomType
        }else{
            let roomObj ={};
            roomBasicInfoList.map(room=>{
                if(roomId === room.roomId){
                    roomObj = room;
                }
                return room;
            });
            roomId = roomObj['roomId'];
            roomName = roomObj['roomName'];
            roomType = roomObj['roomType']
        }

        yield put({type:ActionTypes.GET_PROJECT_SUCCESS, data:projectData});
        yield put({type:ActionTypes.DQC_DETAILS,data:{isDqcDataPresent,dqcUpdateMode:false,dqcAddMode:!isDqcDataPresent}});
        yield put({type: ActionTypes.SET_CUSTOMER_DETAILS, data: projectData['customer_details']})
        yield put({type: ActionTypes.GET_ROOM_INFO_LIST, data: roomBasicInfoList});
        yield put({type: ActionTypes.SET_ROOM_NAME, data:roomName })
        yield put({ type: ActionTypes.SET_FLOORS_DATA, data: scProjectData.floors });
        yield put((getPlanOverViewData({projectData, roomId, roomType, floorsData: scProjectData.floors })));
    } catch (error) {
        console.error("Error in getProjectDetails", error);
        yield put({type:ActionTypes.GET_PROJECT_FAILURE, data: {error: "Error while gettting project details!"}})
    }
}

// function sortObjectArray(array, sortOrder){
//     try {
//         let result = [];
//         return array.map(function(item) {
//         var n = sortOrder.indexOf(item['type']);
//         sortOrder[n] = '';
//         return [n, item]
//         }).sort().map(function(j) { return j['type'] })       
//     } catch (error) {
//         console.error("Error in sortObjectArray", error);
//     }
// }

function* getPlanOverView({data}){
    try {
        document.body.style.transform = '75%'
        yield put({type: ActionTypes.PAGE_LOADING_STATUS, status:'beginning'});
        let {projectData, roomId, roomType, floorsData} = data;
        if(roomType){
            roomType = roomType.toLowerCase() === 'kitchen' ? "kitchen": "default";
        }
        let {opportunityId, version} = projectData;
        //Handle instruction pages
        let instructionCatList = new Set();
        const planOverView = yield fetch(`${getSpacecraftDrawingUrl()}projects/${opportunityId}/rooms/${roomId}/planoverview`,{
            headers:{
                "Authorization": yield select(accessToken)
            }
        });
        if(planOverView && planOverView.status === 500){
            //let projectId = `${projectData.opportunityId}_${projectData.version}`; 
            yield put({type:ActionTypes.GET_PROJECT_FAILURE, data:{error: "2D Drawing are not available"}});
            //yield put((setPageData({pageNumber:1, projectData }))) 
            return;
        }
        const planOverViewResp = yield planOverView.json();
        //const customerId = projectData?.customer_details?.Client_Id;
        let orderProfileType = yield select(orderProfileSelector);
        if(orderProfileType === "DOOWUP"){
            addPDFLinks(instructionsTempleates["doowup"]["other-doowup-modules"], instructionCatList, pdfLinks);
        }
        if(orderProfileType === "DOOWUP" && roomType === "kitchen"){
            addPDFLinks(instructionsTempleates["d-kitchen"]["kitchen"], instructionCatList, pdfLinks);
        }

        if(!['DOOWUP', 'HOMELANE']?.includes(orderProfileType)) {
            orderProfileType = 'HOMELANE'
        }
        

        const hdsServicesData = yield fetch(`${getSpacecraftDrawingUrl()}projects/${opportunityId}/rooms/${roomId}/services`);
        if(hdsServicesData && hdsServicesData.status === 500){
            //let projectId = `${projectData.opportunityId}_${projectData.version}`; 
            yield put({type:ActionTypes.GET_PROJECT_FAILURE, data:{error: "2D Drawing are not available"}});
            return;
        }
        const hdsServicesData_json = yield hdsServicesData.json();
        if(planOverViewResp && Object.keys(planOverViewResp).length>0){
            let {roomId,roomName, roomType, elevationInfoList, applianceSize, lightingSize, isFlooringAppliedInRoom, hasCountertop, categorySubcategoryRoom, perspectiveImages, planImageUrl, roomFloorPlanImageUrl,countertopElevationInfoList=[],countertopSize, falseCeilingData, customWoodWorkView, hdsSequenceData, curtainsData } = planOverViewResp;
            let room_notes;
            room_notes = roomNotes[orderProfileType][roomType];
            if(room_notes){
                yield put({type: ActionTypes.SET_ROOM_NOTES, data: room_notes})
            }
            else{
                yield put({type: ActionTypes.SET_ROOM_NOTES, data: roomNotes[orderProfileType]['default']});
            }            
            let actualRoomType=roomType?.toLowerCase();
            if(roomType){
                roomType = roomType.toLowerCase() === 'kitchen' ? "kitchen": "default";
            }
            let roomDetails = {}
            roomDetails[roomId] = {
                roomName,
                roomType,
                pages:{}
            };
            roomType = roomType.toLowerCase();
            const modules_data = yield fetch(`${getSpacecraftDrawingUrl()}projects/${opportunityId}/rooms/${roomId}/modules`, { headers:{ "Authorization": yield select(accessToken) } });
            const modules_response  = yield modules_data.json();
            const looseFurniture =  yield fetch(`${getSpacecraftDrawingUrl()}projects/${opportunityId}/rooms/${roomId}/looseFurniture`, { headers:{ "Authorization": yield select(accessToken) } });
            const looseFurnitureJson  = yield looseFurniture.json();
            const other_services = yield fetch(`${getSpacecraftDrawingUrl()}projects/${opportunityId}/room/${roomId}/allservices`);
            if(other_services && (other_services.status===500 || other_services.status ===404)){
                yield put({type:ActionTypes.GET_PROJECT_FAILURE, data:{error: "Other Service Data Not Available"}});
                return;
            }
            const other_services_response = yield other_services.json();
            const projectRFQ =  yield fetch(`${getSpacecraftUrl()}api/v1/rfq/${opportunityId}`, { headers:{ "Authorization": yield select(accessToken) } });
            const projectRFQJson  = yield projectRFQ?.json();
            let rfqDetails: any = {};
            if(projectRFQJson?.length) {
                const findCurrentRFQ = projectRFQJson?.find(rfq => rfq.addedToSC);
                if(findCurrentRFQ?.rfqId) {
                    const rfqResp =  yield fetch(`${process.env.REACT_APP_RFQ_URL}api/rfqs/${findCurrentRFQ?.rfqId}/details`);
                    const rfqRespJson  = yield rfqResp?.json();
                    const rfqRespData = rfqRespJson?.products?.filter(item => item?.roomId === roomId);
                    if(rfqRespData?.length) {
                        rfqDetails = {
                            ...rfqRespJson,
                            products: [...rfqRespData],
                        };
                    }
                }
            }

            let dqcCommentsData:any = [];

            if(floorsData?.length > 0){
                let dqcComments = yield fetch(`${getSpacecraftUrl()}api/v1.0/project/${opportunityId}/floors/${floorsData[0].id}/room/${roomId}/DqcException`, { headers:{ "Authorization": yield select(accessToken) } });
                dqcCommentsData = yield dqcComments?.json();
            }

            // let pageNotes = yield fetch(`${process.env.REACT_APP_DRAWING_API_URL}roomInfo/roomType/${roomType}/key/notes`);
            // pageNotes = yield pageNotes.json();
            // if(pageNotes && !pageNotes.error){
            //     let {roomInfo} = pageNotes;
            //     let {notes} = roomInfo;
            //     console.log(notes);
            //     if(notes){
            //         yield put({type: ActionTypes.SET_ROOM_NOTES, data: notes})
            //     }
            // }
            let overView = cloneDeep(template['pages'][roomType]['OVERVIEW']);
            let overView2 = cloneDeep(template['pages'][roomType]['OVERVIEW2'])
            let overViewPageList = []
            let startIndex = 1;
            overView["sidebarInfo"]=sidebarInfo[orderProfileType]['OVERVIEW'][actualRoomType];
            overView2["sidebarInfo"]=sidebarInfo[orderProfileType]['OVERVIEW'][actualRoomType];
            
            perspectiveImages = perspectiveImages?.filter(image=> image && !image?.imageName?.includes('_Zones_')) || [];            
            if(perspectiveImages && perspectiveImages.length){
                let chuck1 = perspectiveImages.splice(0,4)
                overView['perspectiveImages'] = chuck1;
                overView['planImageUrl'] = planImageUrl;
                overView['roomFloorPlanImageUrl'] = roomFloorPlanImageUrl;
                overViewPageList.push(overView)
                
                let chunkSplit = [];
                if(perspectiveImages && perspectiveImages.length){
                    let splitCount = perspectiveImages.length/6;
                    chunkSplit = splitArrayChunks(perspectiveImages, splitCount);
                }
                (chunkSplit || []).map((chunk, index)=>{
                    let pageObj = cloneDeep(overView2);
                    pageObj['perspectiveImages'] = chunk;
                    pageObj['name'] = `Overview - ${index+1}`;
                    pageObj['type'] = "overviewSubPage";
                    pageObj['pageType'] = "overviewSubPage";
                    overViewPageList.push(pageObj)
                    return chunk;
                })
                overViewPageList.map((ovPage, index)=>{
                    ovPage['pageNumber'] = index+1;
                    roomDetails[roomId]['pages'][index+1] = ovPage;
                    startIndex++;
                    return ovPage;
                })

            }
            // Checking if quote generate after 14 Feb 2024.
            const newPageView = planOverViewResp?.projectCreatedTimestamp > 1711045800000;

            const gettingLightingType = (lightingData) => {
                if(!lightingData) {
                    return
                }
                const lightTypeArray = ['driver', 'spot', 'panel', 'cove', 'strip', 'tracklight', 'track', 'spotlight', 'chandelier', 'profile', 'pendant'];
                const lightingArray = lightingData;


                // Function to check if a string contains any substring from an array
                const containsAny = (str, substrings) => {
                    for (let substring of substrings) {
                        if (str.includes(substring.toLowerCase())) {
                            return substring;
                        }
                    }
                    return null;
                };

                // Iterate over each object and add the 'type' property if a matching substring is found
                for (let obj of lightingArray) {
                    const matchedType = containsAny(obj?.name?.toLowerCase() || obj?.description?.toLowerCase(), lightTypeArray);
                    if (matchedType) {
                        obj.light_type = matchedType;
                    }
                }
                return lightingArray
            }

            let planView = cloneDeep(template['pages'][roomType]['PLAN']);
            planView = setPageTemplates(planOverViewResp, planView)
            //PlanView multiple page changes
            let planPage = cloneDeep(planView)
            
            // Todo: Hack to show to plane page image in paint flow.
            let measuredPlanPageImg;
            planPage["sidebarInfo"]=sidebarInfo[orderProfileType]['PLAN'][actualRoomType];
            if(roomType){
                let eleIndex = startIndex;
                let planData = yield fetch(`${getSpacecraftDrawingUrl()}projects/${opportunityId}/rooms/${roomId}/planview`,{ headers:{ "Authorization": yield select(accessToken) } })
                planData = yield planData.json()
                let { measuredPlanImageUrl,carcassMaterialSpecificationList, frameAndShutterSpecification, handles, handleProfile, handleProfiles} = planData;
                measuredPlanPageImg = measuredPlanImageUrl
                if(carcassMaterialSpecificationList?.length){
                    (carcassMaterialSpecificationList || []).map(obj=>{
                        let productName = obj['productName'];
                        let carcassData=obj.carcassData;
                        let parentData=carcassData.length>0?carcassData.reduce((acc,data)=>{
                           return acc["moduleNumbers"]?.length>data['moduleNumbers']?.length?acc:data;
                        },carcassData[0]):{...carcassData[0]};
                        let listData=[]
                        let tableCount=1;
                        carcassData.map((data)=>{
                            let name=data.carcassMaterial;
                            if(parentData && data.carcassColorCode!==parentData?.carcassColorCode){
                                let moduleNames=data.moduleNumbers.length>1?data.moduleNumbers?.join(","):data.moduleNumbers[0];
                                name=`${data.carcassMaterial}(${moduleNames})`
                            }
                            if(listData.length<3){
                                listData.push({
                                    carcassMaterial:name,
                                    carcassColorCode:data.carcassRefCode || data.carcassColorCode,
                                    carcassColor:data.carcassColor
                                })
                            }
                            else{
                                planPage['carcaseDetails'][`${productName}_${tableCount}`] = listData;
                                listData=[];
                                tableCount++;
                            }
                            return data;
                        })
                        if(listData.length){
                         planPage['carcaseDetails'][`${productName}_${tableCount}`] = listData;
                        }
                        return obj;
                    })
                }
                const frameKeys = Object.keys(frameAndShutterSpecification) || [];
                planPage = mapTemplateKeys(planPage, frameKeys, frameAndShutterSpecification, 'frameAndShutterSpecification');
                if(handleProfiles?.length) {
                    planPage['carcaseDetails'][`PROFILE`] = handleProfiles;
                } else if(handleProfile?.name) {
                    const profileArray = []
                    let profileData = {
                        name: handleProfile?.name,
                        type: handleProfile?.type,
                        image: handleProfile?.image
                    }
                    profileArray.push(profileData);
                    planPage['carcaseDetails'][`PROFILE`] = profileArray;
                }
                if(handles && handles.length > 0){
                    let handlesArry =[];
                    handles.map(handle=>{
                        if(handle['handleData'] && Object.keys(handle['handleData']).length > 0){
                            let handleData = {
                                item: handle['handleData']['isInternal'] ? handle['handleData']['name']+" (Int)" : handle['handleData']['name'],
                                code: handle['handleData']['id'],
                                size: handle['handleData']['size']+" mm",
                                pitch: handle['handleData']['pitch']+" mm",
                                partType:handle['partType'],
                                image: handle['handleData']['image'],
                                budgetType:handle['handleData']['budgetType']
                            };
                            if(roomType !== "kitchen"){
                                handleData.partType = handle.subCategoryName;
                            }
                            handlesArry.push(handleData);
                        }
                        return handle;
                    });
                    if(handlesArry && handlesArry.length > 0){
                        // handlesArry = handlesArry.filter((elem, index, self) => self.findIndex(
                        //     (t) => {return (t.item == elem.item && t.code == elem.code)}) === index)
                        handlesArry=handlesArry.sort((a, b) => a.partType.localeCompare(b.partType));
                        for(let i=0;i<handlesArry.length;i+=maxRowsHandleTable){
                            let tempArray=handlesArry.slice(i,i+maxRowsHandleTable);
                            planPage['carcaseDetails'][`HANDLES_${i}`] = tempArray;
                        }   
                    }
                }
                let {carcaseDetails} = planPage
                let planKeys = Object.keys(carcaseDetails)
                if(planKeys && planKeys.length){
                    let planSplint = Math.ceil(planKeys.length)/5;
                    let planSplitKeys = splitArrayChunks(planKeys, planSplint)
                    let elevationName = planPage['name']
                    for(var index=0; index<planSplitKeys.length; index++){
                        let split = planSplitKeys[index]
                        let newPage = cloneDeep(template['pages'][roomType]['PLAN']);
                        newPage["sidebarInfo"]=sidebarInfo[orderProfileType]['PLAN'][actualRoomType];
                        newPage['carcaseDetails'] = {}
                        split.map(splitKey=>{
                            newPage['carcaseDetails'][splitKey] = carcaseDetails[splitKey] 
                            return splitKey;
                        })
                        newPage['name'] = `${elevationName} - ${index+1}`;
                        newPage['measuredPlanImageUrl'] = measuredPlanImageUrl;
                        newPage['pageNumber'] = eleIndex;
                        roomDetails[roomId]['pages'][eleIndex] = cloneDeep(newPage)
                        eleIndex++;
                    }
                    
                }

            } 
            // }else{
            //     roomDetails[roomId]['pages'][startIndex] = cloneDeep(planView);
            // }
            let elevationViews = [];
            let HDSElevationsViews = {};
            let paintingPageCreated = false;
            let pageOrder = ["DIMENSION", "MATERIAL","SHUTTER_MATERIAL", "SHUTTER_EXTENSION","INTERNAL","CROSSSECTION","SITEDETAIL", "ELECTRICAL","WALL_TILE", "PLUMBING","GAS_OUTLET", 'WALL_CLADDING'];

            if(elevationInfoList && elevationInfoList.length){ 

                elevationInfoList.sort((a, b)=>{
                    return a.elevationViewName === b.elevationViewName ? 0 : a.elevationViewName < b.elevationViewName ? -1 : 1;
                })

                elevationInfoList.map(elevation=>{
                    let {elevationViewId, elevationViewName, elevationTypes } = elevation;
                    if(elevationViewId){
                        // let eleObj = createElevationViews(elevationViewId, elevationViewName, roomType);
                        // eleObj = Object.assign({},eleObj);
                        // elevationViews.push(eleObj);
                        //handling the elevation types
                        if(elevationTypes && elevationTypes.length > 0){
                            elevationTypes.sort((a,b)=>{
                                return pageOrder.indexOf(a) - pageOrder.indexOf(b);
                            });
                            elevationTypes.map(eleType=>{
                                //Add HDS PDF links 
                                if(eleType?.includes('WALL_DECOR_PAINTING')){   
                                    addPDFLinks(instructionsTempleates["hdsServices"].painting, instructionCatList, pdfLinks);
                                } else if(eleType?.includes('WALL_DECOR_WALLPAPER')){
                                    addPDFLinks(instructionsTempleates["hdsServices"].wallpaper, instructionCatList, pdfLinks);
                                } else if(eleType?.includes('WALL_CLADDING')){
                                    addPDFLinks(instructionsTempleates["hdsServices"].wallCladding, instructionCatList, pdfLinks);
                                }

                                let elecElevation = cloneDeep(template['pages'][eleType]);
                                if(['INTERNAL', 'MATERIAL', 'DIMENSION','SHUTTER_MATERIAL',"SHUTTER_EXTENSION",'CROSSSECTION','SITEDETAIL','GAS_OUTLET','LIGHTING','WALL_TILE'].includes(eleType)){
                                    elecElevation = cloneDeep(template['pages'][roomType][eleType]);
                                }
                                elecElevation['elevationId'] = elevationViewId;

                                elecElevation['name'] = `${elevationViewName} - ${eleType.toLowerCase()}`;
                                if(eleType && eleType.includes('WALL_DECOR')){
                                    if(paintingPageCreated && eleType === 'WALL_DECOR_PAINTING'){
                                        return;
                                    }
                                    if(!paintingPageCreated && newPageView && eleType === 'WALL_DECOR_PAINTING') {
                                        paintingPageCreated =  true;
                                        elecElevation['type'] = 'WALL_DECOR_NEW';
                                        elecElevation['name'] = `Wall - Painting`;
                                        elecElevation['planImageUrl'] = measuredPlanPageImg;
                                    } else {
                                        let eleName = eleType.split('_');
                                        let serviceName = "painting";
                                        if(eleName.length > 2){
                                            serviceName = `${eleName[eleName.length-1].toLowerCase()}`;
                                        }
                                        elecElevation['name'] = `${elevationViewName} - ${serviceName}`;
                                    }
                                }
                                if(eleType === 'ELECTRICAL') {
                                    // Changing Electrical type to new Electrical
                                    elecElevation['type'] = newPageView ? 'WALL_ELECTRICAL' : 'ELECTRICAL'
                                }
                                if(eleType === 'WALL_CLADDING') {
                                    // Add custom wall cladding name
                                    elecElevation['name'] = `${elevationViewName} - Wall Cladding`
                                }
                                elevation['sc_elevation_name'] = elevationViewName;
                                if(["ELECTRICAL", "PLUMBING", "WALL_TILE", 'WALL_CLADDING'].includes(eleType) || eleType.includes('WALL_DECOR', '')){
                                   HDSElevationsViews[eleType]?HDSElevationsViews[eleType].push(elecElevation):HDSElevationsViews[eleType]=[elecElevation];
                                }
                                else{                                    
                                   elevationViews.push(elecElevation);
                                }
                                return eleType;

                            })
                        }
                    }
                    return elevation;
                    })
            }
           
            // Adding HDSElevation pages
            if(Object.keys(HDSElevationsViews).length){
                Object.keys(HDSElevationsViews).map((eleType)=>{
                     elevationViews.push(...HDSElevationsViews[eleType]);
                     return eleType;
                })
            }
            let internalEles = {};
            let shutterEles = {};
            //let planViews={};
            let dimensionEles={};
            let materialEles={};
            let lightingEles={};
            let paintEles={};
            let wallCladdingEles={};
            let lightingItemsDetails;
            if(elevationViews && elevationViews.length){
                for(var eleIndex=0; eleIndex < elevationViews.length ; eleIndex++){
                    let elevation = elevationViews[eleIndex]
                    if(elevation['type'] === "DIMENSION"){
                        let { elevationId } = elevation;
                        let dimension =  yield fetch(`${getSpacecraftDrawingUrl()}projects/${opportunityId}/rooms/${roomId}/elevation/${elevationId}/dimension`,{ headers:{ "Authorization": yield select(accessToken) } });
                        dimension = yield dimension.json();
                        let {skirtings,carcassDepthList,loftSlabPresent,softCloseSpecifications,elevationImage, poojaMandir, metaData, dimensionTPattiData} = dimension;
                        let skirtingData = {'skirting':[]};
                        let numOfSplitsDim = 0;
                        if(skirtings && skirtings.length>0){
                            let skirting_pvc = {'details':{'SKIRTING HEIGHT':'','SKIRTING COLOR':''},'heading':'PVC SKIRTING DETAILS'};
                            let skirting_wooden = [];
                            skirtings?.map(skirting => {
                                if(skirting?.skirtingId){
                                let skirtingHeight = skirting?.['skirtingHeight'] || skirting?.['leg']?.['height'];
                                if(!skirting_pvc['details']['SKIRTING HEIGHT']?.includes(skirtingHeight)){
                                    skirting_pvc['details']['SKIRTING HEIGHT'] += skirtingHeight+"MM,";
                                }
                                if(!skirting_pvc['details']['SKIRTING COLOR']?.includes(skirting['color']['colourName'])){
                                    skirting_pvc['details']['SKIRTING COLOR'] +=  skirting['color']['colourName']+",";
                                }
                                }
                                else{
                                    let wSkirtingHeight = skirting?.['skirtingHeight'] || skirting?.['leg']?.['height'];
                                    let wSkirtingColor = skirting['color']['colourName'];
                                    let wSkirtingType = skirting['skirtingType']
                                    skirting_wooden?.push({'details':{'SKIRTING HEIGHT':wSkirtingHeight,'SKIRTING COLOR':wSkirtingColor, 'SKIRTING TYPE': wSkirtingType},'heading':'WOODEN SKIRTING DETAILS'})
                                }
                            })
                            if(skirting_pvc['details']['SKIRTING HEIGHT'] || skirting_pvc['details']['SKIRTING COLOR']){
                                    skirtingData['skirting'].push(skirting_pvc);
                            }
                            skirtingData['skirting'].push(...skirting_wooden);
                            
                        }
                        // else{
                        //      skirtingData['skirting'].push({'details':{'SKIRTING HEIGHT':'NA','SKIRTING COLOR':'NA'},'heading':'PVC SKIRTING DETAILS'})
                        // }
                        let elevationName = elevation['name'];
                        elevation['elevationImage'] = elevationImage;
                        elevation['poojaMandir'] = poojaMandir;
                        elevation['metaData'] = metaData;
                        numOfSplitsDim = Math.ceil(skirtingData['skirting'].length/3);
                        let splits = splitArrayChunks(skirtingData['skirting'], numOfSplitsDim);
                        let newPage = cloneDeep(elevation);
                        let noDimPages = splits.length || 1;
                        for(var i=0;i<noDimPages;i++){
                            if(i===0){
                                elevation['skirting']=splits[i];
                                elevation['name'] = `${elevationName} - ${i+1}`
                                if(softCloseSpecifications && softCloseSpecifications.length){
                                    elevation['softCloseSpecifications'] = softCloseSpecifications
                                }
                                if(carcassDepthList && carcassDepthList.length){
                                     elevation['carcassDepthList'] = carcassDepthList
                                 }
                                if(dimensionTPattiData && Object.keys(dimensionTPattiData).length){
                                     elevation['dimensionTPattiData'] = dimensionTPattiData
                                 }
                                 elevation['loftSlabPresent'] = loftSlabPresent;
                                 continue;
                            }
                            else{
                                newPage['name'] = `${elevationName} - ${i+1}`
                                newPage['skirting']=splits[i];
                            }
                            if(Object.keys(dimensionEles).length){
                                dimensionEles[eleIndex+index] = newPage
                            }else{
                                dimensionEles[eleIndex+1] = newPage;
                            }
                        }

                    }
                    if(elevation['type'] === "MATERIAL"){
                        let { elevationId } = elevation;
                        let material = yield fetch(`${getSpacecraftDrawingUrl()}projects/${opportunityId}/rooms/${roomId}/elevation/${elevationId}/material`,{ headers:{ "Authorization": yield select(accessToken) } });
                        material = yield material.json();
                        let {colorSpecificationList, shutterMaterialSpecificationList, elevationImage, metaData} = material;
                        elevation['elevationImage'] = elevationImage;
                        elevation['metaData'] = metaData;
                        if(colorSpecificationList && colorSpecificationList?.length>4){
                            for(let i=0;i<colorSpecificationList.length;i+=4){
                                let tempArray=colorSpecificationList.slice(i,i+4);
                                if(i===0){
                                    elevation['shutterDetails']['colorSpecificationList'] = tempArray;
                                }
                                else{
                                  elevation['shutterDetails'][`colorSpecificationList_${i}`] = tempArray;
                                }
                            }
                        }
                        else{
                          elevation['shutterDetails']['colorSpecificationList'] = colorSpecificationList;
                        }
                        shutterMaterialSpecificationList && shutterMaterialSpecificationList.map(shutter=>{
                            let productName = shutter['productName'];
                            delete shutter['productName'];
                            shutter['heading'] = productName;
                            let formatedData=[];
                            let tableCount=0;
                            if(shutter['shutterCore']?.length){
                                let shutterCore=shutter['shutterCore'];
                                let parentData=shutterCore.length>0?shutterCore.reduce((acc,data)=>{
                                     if(data.shutterMaterial){
                                       let material= acc['shutterMaterial']?.moduleNumbers?.length>data.shutterMaterial['moduleNumbers']?.length?acc['shutterMaterial']:data['shutterMaterial'];
                                       acc['shutterMaterial']=material;
                                     }
                                     return acc;
                                },{...shutterCore[0]}):{...shutterCore[0]};
                                shutterCore.map(material=>{
                                    if(material?.shutterMaterial){
                                     let name=material?.shutterMaterial?.name;
                                     if(name===" "){
                                        name = "NA";
                                     }
                                     let shutterFinish='';
                                     let shutterFinishAndModulesArray = [];
                                     material['shutterMaterial']['shutterFinishName']?.map((fin,i)=> {
                                        if(i===0){
                                            shutterFinishAndModulesArray.push({"finish":fin,"modules":[material['shutterMaterial'].moduleNumbers[i]]});
                                        }
                                        else{
                                            if(shutterFinishAndModulesArray.filter(obj=> obj.finish===fin).length===0){
                                                shutterFinishAndModulesArray.push({"finish":fin,"modules":[material['shutterMaterial'].moduleNumbers[i]]});
                                            }
                                            else{
                                                shutterFinishAndModulesArray.map(finishModules =>{
                                                    if(finishModules.finish === fin){
                                                        finishModules["modules"].push(material['shutterMaterial'].moduleNumbers[i]);
                                                    }
                                                    return finishModules;
                                                })
                                            }
                                        }
                                    })
                                     shutterFinishAndModulesArray.sort((a, b) => b.modules.length - a.modules.length)
                                     if(parentData?.shutterMaterial?.name!==name){
                                        let moduleNames=material['shutterMaterial'].moduleNumbers.length>1?material['shutterMaterial'].moduleNumbers?.join(","):material.shutterMaterial['moduleNumbers'][0];
                                        name=`${name}(${moduleNames})`
                                        if(shutterFinishAndModulesArray.length ===1){
                                            shutterFinish = shutterFinish + shutterFinishAndModulesArray[0].finish;
                                         }
                                         else{
                                        shutterFinishAndModulesArray.length>1 && shutterFinishAndModulesArray.map((obj ,index)=>{
                                            if(index===0){
                                                shutterFinish = shutterFinish + shutterFinishAndModulesArray[index].finish;
                                            }
                                            else{
                                                shutterFinish = shutterFinish + ","+(shutterFinishAndModulesArray[index].finish+ "(" + shutterFinishAndModulesArray[index].modules.join(",")+")")
                                            }
                                            return obj;
                                         })
                                        }
                                    }
                                    else{
                                        if(shutterFinishAndModulesArray.length ===1){
                                            shutterFinish = shutterFinish + shutterFinishAndModulesArray[0].finish;
                                         }
                                         else{
                                         shutterFinishAndModulesArray.length>1 && shutterFinishAndModulesArray.map((obj ,index)=>{
                                            if(index===0){
                                                shutterFinish = shutterFinish + shutterFinishAndModulesArray[index].finish;
                                            }
                                            else{
                                                shutterFinish = shutterFinish + ","+(shutterFinishAndModulesArray[index].finish+ "(" + shutterFinishAndModulesArray[index].modules.join(",")+")")
                                            }
                                            return obj;
                                         })
                                        }
                                    }
                                     if(formatedData.length<2){
                                       formatedData.push({"shutterMaterial":name,"shutterFinish":shutterFinish})
                                     }
                                     else{
                                        elevation['shutterDetails'][`${productName}_${tableCount}`] = {
                                            [productName]: formatedData,
                                            "heading":  productName?.toLowerCase()?.includes('unit')?productName.toUpperCase():`${productName.toUpperCase()} UNIT`
                                        }
                                        formatedData=[];
                                        formatedData.push({"shutterMaterial":name,"shutterFinish":shutterFinish});
                                        tableCount++;
                                     }

                                    }
                                    return material;
                                })
                            }
                            if(formatedData.length){
                                elevation['shutterDetails'][`${productName}_${tableCount}`] = {
                                    [productName]: formatedData,
                                    "heading":   productName?.toLowerCase()?.includes('unit')?productName.toUpperCase():`${productName.toUpperCase()} UNIT`
                                }
                            }
                            return shutter;
                         })

                        if(metaData && metaData.length){
                            elevation['shutterDetails']['nsdDetails'] = metaData;
                        }

                        let shutterDetailsKeys = Object.keys(elevation['shutterDetails']);
                        if(shutterDetailsKeys.length > 4){
                            let elevationName = elevation['name'];
                            let fullShutterDetails = elevation['shutterDetails'];
                            let keyChunks = [];
                            for(let i=0;i<shutterDetailsKeys.length;i+=4){
                                keyChunks.push(shutterDetailsKeys.slice(i,i+4));
                            }
                            keyChunks.map((chunkKeys, index) => {
                                let chunkDetails = {};
                                chunkKeys.map(chunkKey=>{
                                    chunkDetails[chunkKey] = fullShutterDetails[chunkKey];
                                    return chunkKey;
                                });
                                if(index===0){
                                    elevation['shutterDetails'] = chunkDetails;
                                    elevation['name'] = `${elevationName} - ${index+1}`
                                    return chunkKeys;
                                }
                                let newPage = cloneDeep(elevation);
                                newPage['shutterDetails'] = chunkDetails;
                                newPage['name'] = `${elevationName} - ${index+1}`
                                if(Object.keys(materialEles).length){
                                    materialEles[eleIndex+index] = newPage
                                }else{
                                    materialEles[eleIndex+1] = newPage
                                }
                                return chunkKeys;
                            })
                        }
                    }
                    if(elevation['type'] === "SHUTTER_MATERIAL"){
                        let { elevationId } = elevation;
                        let shutter =  yield fetch(`${getSpacecraftDrawingUrl()}projects/${opportunityId}/rooms/${roomId}/elevation/${elevationId}/shuttermaterial`,{ headers:{ "Authorization": yield select(accessToken) } });
                        shutter = yield shutter.json();
                        let {colorSpecificationList,sectionDataList,elevationImage,shutterMaterialSpecificationList, handleData, metaData} = shutter;
                        elevation['elevationImage'] = elevationImage;
                        
                        // if(sectionDataList && sectionDataList.length > 0){
                            let numOfSplits = Math.ceil(sectionDataList.length/6);
                            let splits = splitArrayChunks(sectionDataList, numOfSplits);
                                let elevationName = elevation['name'];
                                for(let index=0; index<splits.length+1; index++){
                                   
                                    let noColorSplits = Math.ceil(colorSpecificationList.length/5);
                                    let colorSplits = splitArrayChunks(colorSpecificationList,noColorSplits);
                                    if(index===0){
                                        delete elevation['shutterDetails']['colorSpecificationList'];
                                        for(let j=0;j<noColorSplits;j++){
                                            elevation['shutterDetails']['colorSpecificationList_'+j] = colorSplits[j]; 
                                        }
                                        // for(let i=0;i<4;i++){
                                        //     elevation['sectionDetails']['sectionDataList_'+i] = subsplits[i];
                                        // }
                                        elevation['name'] = `${elevationName} - ${index+1}`
                                        shutterMaterialSpecificationList && shutterMaterialSpecificationList.map(shutter=>{
                                            let productName = shutter['productName'];
                                            delete shutter['productName'];
                                            shutter['heading'] = productName;
                                            let formatedData=[];
                                            let tableCount=0;
                                            if(shutter['shutterCore']?.length){
                                                let shutterCore=shutter['shutterCore'];
                                                shutterCore.map((material,index)=>{
                                                    if(material?.shutterMaterial && index===0){
                                                     let frameName = material?.shutterMaterial?.frameName;
                                                     let frameColor = material?.shutterMaterial?.frameColor;
                                                     let frameColors = material?.shutterMaterial?.frameColor?.split(",");
                                                     if(frameColors?.length == material?.shutterMaterial?.moduleNumbers?.length){
                                                        frameColors = frameColors?.map((color,i) => {
                                                            return color + " (" + material?.shutterMaterial?.moduleNumbers[i] + ")";
                                                        })
                                                        frameColor = frameColors.join(",");
                                                     }
                                                     if(formatedData.length<3){
                                                       formatedData.push({"frameName":frameName,"frameColor":frameColor})
                                                     }
                                                     else{
                                                        elevation['shutterDetails'][`${productName}_${tableCount}`] = {
                                                            [productName]: formatedData,
                                                            "heading":  productName?.toLowerCase()?.includes('unit')?productName.toUpperCase():`${productName.toUpperCase()} UNIT`
                                                        }
                                                        tableCount++;
                                                        formatedData=[];
                                                     }
                                                    }
                                                    return material;
                                                })
                                            }
                                            if(formatedData.length){
                                                elevation['shutterDetails'][`${productName}_${tableCount}`] = {
                                                    [productName]: formatedData,
                                                    "heading":   productName?.toLowerCase()?.includes('unit')?productName.toUpperCase():`${productName.toUpperCase()} UNIT`
                                                }
                                            }
                                            if(handleData?.length){
                                                elevation['shutterDetails']['handleData'] = handleData;
                                            }
                                            return shutter;
                                         })
                                        if(metaData && metaData.length){
                                            elevation['shutterDetails']['nsdDetails'] = metaData;
                                        }
                                        // if(splits.length==1){
                                        //     elevation['designDetails'] = designDataList;
                                        // }

                                        continue;
                                    }
                                    // numOfSplitsDim = Math.ceil(skirtingData['skirting'].length/3);
                                    // let splits = splitArrayChunks(skirtingData['skirting'], numOfSplitsDim);
                                    // let newPage = cloneDeep(elevation);
                                    console.log("splits",elevation);
                                    let newPage = cloneDeep(elevation);
                                    let split = splits[index-1]
                                    let subsplits = splitArrayChunks(split, 3);
                                    delete newPage['shutterDetails'];
                                    for(let i=0;i<3;i++){
                                        newPage['sectionDetails']['sectionDataList_'+i] = subsplits[i];
                                    }
                                    // }
                                   // newPage['sectionDetails'] = split;
                                    newPage['name'] = `${elevationName} - ${index+1}`
                                    
                                    if(Object.keys(shutterEles).length){
                                        shutterEles[eleIndex+index] = newPage
                                    }else{
                                        shutterEles[eleIndex+1] = newPage
                                    }
                                
                                }
                            // }
                    }
                    if(elevation['type'] === "INTERNAL"){
                        let { elevationId } = elevation;
                        let internals = yield fetch(`${getSpacecraftDrawingUrl()}projects/${opportunityId}/rooms/${roomId}/elevation/${elevationId}/internal`,{ headers:{ "Authorization": yield select(accessToken) } })
                        internals = yield internals.json()
                        let {accessorySpecificationList, elevationImage} = internals;
                        elevation['elevationImage'] = elevationImage;
                        Object.keys(sidebarInfo[orderProfileType]["INTERNAL"]).map(subcategory=>{
                            if(elevation?.name?.toLowerCase().includes(subcategory)){
                                elevation['sidebarInfo']=sidebarInfo[orderProfileType]["INTERNAL"][subcategory];
                            }
                            return subcategory;
                        })
                        accessorySpecificationList.sort((a,b) => (a.accessoryAnnotationId?.localeCompare(b.accessoryAnnotationId)));
                        if(accessorySpecificationList && accessorySpecificationList.length){
                            let numOfSplits = Math.ceil(accessorySpecificationList.length/7);
                            let splits = splitArrayChunks(accessorySpecificationList, numOfSplits);
                            if(splits && splits.length === 1){
                                elevation['accessorySpecificationList'] = splits[0];
                            }else{
                                let elevationName = elevation['name'];
                                for(let index=0; index<splits.length; index++){
                                    let split = splits[index]
                                    if(index === 0){
                                        elevation['accessorySpecificationList'] = split;
                                        elevation['name'] = `${elevationName} - ${index+1}`
                                        continue;
                                    }
                                    let newPage = cloneDeep(elevation);
                                    newPage['accessorySpecificationList'] = split;
                                    newPage['name'] = `${elevationName} - ${index+1}`
                                    
                                    if(Object.keys(internalEles).length){
                                        internalEles[eleIndex+index] = newPage
                                    }else{
                                        internalEles[eleIndex+1] = newPage
                                    }

                                }
                            }
                        }else{
                            elevation['accessorySpecificationList'] = []
                        }
                        if(internals.hasOwnProperty('isBackPanelAdded')){
                          elevation["notes"]=internals.isBackPanelAdded?"Back panel is added.":"";
                        }
                    }
                    if(elevation['type'] === "LIGHTING"){
                        let { elevationId } = elevation;
                        let lightings = yield fetch(`${getSpacecraftDrawingUrl()}projects/${opportunityId}/rooms/${roomId}/elevation/${elevationId}/lighting`,{ headers:{ "Authorization": yield select(accessToken) } })
                        lightings = yield lightings.json();
                        let {imageData, data} = lightings ;
                        elevation['elevationImage'] = imageData;
                        data.sort((a,b) => (a.point?.localeCompare(b.point)));
                        if(data && data.length){
                            let numOfSplits = Math.ceil(data.length/10);
                            let splits = splitArrayChunks(data, numOfSplits);
                            if(splits && splits.length === 1){
                                elevation['lightingPointsDetails'] = splits[0];
                            }else{
                                let elevationName = elevation['name'];
                                for(let index=0; index<splits.length; index++){
                                    let split = splits[index]
                                    if(index === 0){
                                        elevation['lightingPointsDetails'] = split;
                                        elevation['name'] = `${elevationName} - ${index+1}`
                                        continue;
                                    }
                                    let newPage = cloneDeep(elevation);
                                    newPage['lightingPointsDetails'] = split;
                                    newPage['name'] = `${elevationName} - ${index+1}`
                                    
                                    if(Object.keys(lightingEles).length){
                                        lightingEles[eleIndex+index] = newPage
                                    }else{
                                        lightingEles[eleIndex+1] = newPage
                                    }

                                }
                            }
                        }else{
                            elevation['lightingPointsDetails'] = []
                        }


                    }

                    if (elevation['type'] === "WALL_DECOR_NEW") {
                        let wallDetails = yield fetch(`${getSpacecraftDrawingUrl()}projects/${opportunityId}/room/${roomId}/wallPaint2dd`, { headers: { "Authorization": yield select(accessToken) } })
                        wallDetails = yield wallDetails?.json();
                        if (wallDetails?.data && wallDetails?.data?.length) {
                            let { data } = wallDetails;
                            let numOfSplits = Math.ceil(data.length / 5);
                            let splits = splitArrayChunks(data, numOfSplits);

                            if (splits && splits.length === 1) {
                                elevation['wallDetails'] = splits[0];
                            } else {
                                let elevationName = elevation['name'];
                                for (let index = 0; index < splits.length; index++) {
                                    let split = splits[index]
                                    if (index === 0) {
                                        elevation['wallDetails'] = split;
                                        elevation['name'] = `${elevationName} - ${index + 1}`
                                        continue;
                                    }
                                    let newPage = cloneDeep(elevation);
                                    newPage['wallDetails'] = split;
                                    newPage['name'] = `${elevationName} - ${index + 1}`

                                    if (Object.keys(paintEles).length) {
                                        paintEles[eleIndex + index] = newPage
                                    } else {
                                        paintEles[eleIndex + 1] = newPage
                                    }
                                }
                            }
                        } else {
                            elevation['wallDetails'] = []
                        }
                    }
                    
                    if (elevation['type'] === "WALL_CLADDING") {
                        let wallCladdingDetails = yield fetch(`${getSpacecraftDrawingUrl()}projects/${opportunityId}/rooms/${roomId}/elevation/${elevation['elevationId']}/wallCladding`, { headers: { "Authorization": yield select(accessToken) } })
                        wallCladdingDetails = yield wallCladdingDetails?.json();
                    
                        let data = [];
                        Object.entries(wallCladdingDetails?.metaData?.materialInfo)?.map((e) => data.push({ annotation: e?.[1], name: e?.[0] }))
                        let numOfSplits = Math.ceil(data.length / 3);
                        let splits = splitArrayChunks(data, numOfSplits);

                        if (splits && splits.length === 1) {
                            elevation['wallCladdingDetails'] = splits[0];
                            elevation['images'] = wallCladdingDetails?.imageData
                        } else {
                            let elevationName = elevation['name'];
                            for (let index = 0; index < splits.length; index++) {
                                let split = splits[index]
                                if (index === 0) {
                                    elevation['wallCladdingDetails'] = split;
                                    elevation['images'] = wallCladdingDetails?.imageData;
                                    elevation['name'] = `${elevationName} - ${index + 1}`
                                    continue;
                                }
                                let newPage = cloneDeep(elevation);
                                newPage['wallCladdingDetails'] = split;
                                newPage['name'] = `${elevationName} - ${index + 1}`

                                if (Object.keys(wallCladdingEles).length) {
                                    wallCladdingEles[eleIndex + index] = newPage
                                } else {
                                    wallCladdingEles[eleIndex + 1] = newPage
                                }
                            }
                        }
                    }                 
                }
            }

            let wallCladdingKeys = Object.keys(wallCladdingEles);
            if(wallCladdingKeys.length){
                wallCladdingKeys.map(pageIndexKey =>{
                    elevationViews.splice(parseInt(pageIndexKey), 0, wallCladdingEles[pageIndexKey])
                    return pageIndexKey;
                })
            }

            let dimensionKeys = Object.keys(dimensionEles);
            if(dimensionKeys.length){
                dimensionKeys.map(pageIndexKey =>{
                    elevationViews.splice(parseInt(pageIndexKey), 0, dimensionEles[pageIndexKey])
                    return pageIndexKey;
                })
            }
            let materialKeys = Object.keys(materialEles);
            if(materialKeys.length){
                materialKeys.map(pageIndexKey =>{
                    elevationViews.splice(parseInt(pageIndexKey), 0, materialEles[pageIndexKey])
                    return pageIndexKey;
                })
            }
            let shutterKeys = Object.keys(shutterEles);
            if(shutterKeys.length){
                shutterKeys.map(pageIndexKey =>{
                    elevationViews.splice(parseInt(pageIndexKey), 0, shutterEles[pageIndexKey])
                    return pageIndexKey;
                })
            }
            let objKeys = Object.keys(internalEles);
            if(objKeys.length){
                objKeys.map(pageIndexKey=>{
                    elevationViews.splice(parseInt(pageIndexKey), 0, internalEles[pageIndexKey])
                    return pageIndexKey;
                })
            }
            let lightKeys = Object.keys(lightingEles);
            if(lightKeys.length){
                lightKeys.map(pageIndexKey=>{
                    elevationViews.splice(parseInt(pageIndexKey), 0, lightingEles[pageIndexKey])
                    return pageIndexKey;
                })
            }
            let paintKeys = Object.keys(paintEles);
            if(paintKeys?.length){
                paintKeys.map(pageIndexKey=>{
                    elevationViews.splice(parseInt(pageIndexKey), 0, paintEles[pageIndexKey])
                    return pageIndexKey;
                })
            }
            pageindex = Object.keys(roomDetails[roomId]['pages']).length +1;
            if(elevationViews && elevationViews.length){
                elevationViews.map(ele=>{
                    ele.pageNumber = pageindex;
                    roomDetails[roomId]['pages'][pageindex] = cloneDeep(ele);
                    pageindex++;
                    return ele;
                })
            }
            //pageindex +=1;
            // if(applianceAvailable){
            //     let applainceObj = Object.assign({}, template['pages']['APPLIANCES']);
            //     applainceObj['pageNumber'] = pageindex.toString();
            //     //applainceObj['name'] = numOfPages == 1 ? `${applainceObj['name']}` : `${applainceObj['name']} ${i}`;
            //     //applainceObj['appPage'] = i;
            //     roomDetails[roomId]['pages'][pageindex] =applainceObj;
            // }

            if(isFlooringAppliedInRoom){
                let flooringPage = cloneDeep(template['pages'][newPageView ? 'WOODEN_FLOORING' : 'FLOORING']);
                flooringPage['pageNumber'] = pageindex.toString();
                roomDetails[roomId]['pages'][pageindex] = flooringPage;
                pageindex +=1;
            }
            //Appliances page login
            if(applianceSize > 0){
                const applianceResp = yield fetch(`${process.env.REACT_APP_SPACECRAFT_DRAWING_URL}projects/${opportunityId}/rooms/${roomId}/appliance`, { headers:{ "Authorization": yield select(accessToken) } });
                const applianceJson  = yield applianceResp?.json();

                let { applianceList } = applianceJson;
                applianceList = (applianceList || []).filter((item:any) => item.isPriceIncluded !== false);
                // let { appPage } = pageData;
                const integratedAppliances = applianceList.filter((item:any) => item.isIntegratedAppliance === true);
                let nonIntegratedAppliances = applianceList.filter((item:any) => item.isIntegratedAppliance !== true);
                let countedObj={};
                if(nonIntegratedAppliances && nonIntegratedAppliances?.length > 0){
                    nonIntegratedAppliances = nonIntegratedAppliances?.sort((a:any,b:any) => {return a?.applianceName?.localeCompare(b?.applianceName)});
                    countedObj=nonIntegratedAppliances.reduce((acc,item)=>{
                        if(acc[item.productSkuId]){
                            acc[item.productSkuId]["totalCount"]+=Number(item["count"]);
                        }
                        else{
                            item["totalCount"]=Number(item["count"]);
                            acc[item.productSkuId]=item;
                        }
                        return acc;
                    },{})
                }
                integratedAppliances.forEach((item:any) => { item["totalCount"] = Number(item["count"]); });
                applianceList = [...Object.values(countedObj), ...integratedAppliances]
                    .sort((a:any,b:any) => a?.applianceName?.localeCompare(b?.applianceName));
                let numOfAppPages = Math.ceil(applianceList.length/8);
                let splitArray = splitArrayChunks(applianceList, numOfAppPages);
                for(let i=1; i<= numOfAppPages; i++){
                    let applainceObj = cloneDeep(template['pages']['APPLIANCES']);
                    applainceObj['pageNumber'] = pageindex.toString();
                    applainceObj['name'] = numOfAppPages === 1 ? `${applainceObj['name']}` : `${applainceObj['name']} ${i}`;
                    applainceObj['appPage'] = i;
                    roomDetails[roomId]['pages'][pageindex] =applainceObj;
                    applainceObj['applianceList'] = splitArray[i-1];
                    pageindex++;
                }
            }
            if(lightingSize > 0){
                let lightingItemsData = yield fetch(`${getSpacecraftDrawingUrl()}projects/${opportunityId}/rooms/${roomId}/lighting`);
                let response_json = yield lightingItemsData?.json();
                lightingItemsDetails = response_json;
                let { lightingItems } = response_json;
                let countedObj = {};
                if(lightingItems && lightingItems.length > 0){
                    countedObj=lightingItems.reduce((acc,item)=>{
                        if(acc[item.productSku]){
                            acc[item.productSku]["totalCount"]+=item["count"];
                        }
                        else{
                            item["totalCount"]=item["count"];
                            acc[item.productSku]=item;
                        }
                        return acc;
                    },{})
                }
                // let numPlanPages = Math.ceil(lightingSize/maxRowsLightPlanList);
                const divisionValue = newPageView ? 8 : 12
                let numOfOverviewPages = Math.ceil(Object.keys(countedObj).length/divisionValue);
                let reducedLightingData = Object.values(countedObj);
                reducedLightingData = reducedLightingData.sort((a:any,b:any) => {return a?.productSku.localeCompare(b?.productSku)});
                reducedLightingData = reducedLightingData.length ? gettingLightingType(reducedLightingData) : [];
                let splittedLightingData = splitArrayChunks(reducedLightingData,numOfOverviewPages);
                for(let i=1;i<=numOfOverviewPages;i++){
                    let lightingoverview = cloneDeep(template['pages'][newPageView ? 'CABINET_LIGHT' : 'lightingOverview']);
                    lightingoverview['pageNumber'] = pageindex.toString();
                    lightingoverview['name'] = numOfOverviewPages === 1 ? `${lightingoverview['name']}` : `${lightingoverview['name']} ${i}`;
                    lightingoverview['overviewDetails'] = splittedLightingData[i-1];
                    roomDetails[roomId]['pages'][pageindex] = lightingoverview;
                    pageindex +=1;
                }
                // for(let i=1;i<=numPlanPages;i++){
                //     let lightingPlan = cloneDeep(template['pages']['lightingPlanView']);
                //     lightingPlan['pageNumber'] = pageindex.toString();
                //     lightingPlan['name'] = numPlanPages === 1 ? `${lightingPlan['name']}` : `${lightingPlan['name']} ${i}`;
                //     lightingPlan['appPage'] = i;
                //     roomDetails[roomId]['pages'][pageindex] = lightingPlan;
                //     pageindex +=1;
                // }
            }
            //Counter Top
            if(hasCountertop && countertopElevationInfoList?.length===0){
                    let numOfPages = Math.ceil((countertopSize || 1)/maxCounterTopTables);
                    for(let i=1; i<= numOfPages; i++){
                        let moduleObj = cloneDeep(template['pages']['COUNTERTOP']);
                        moduleObj['pageNumber'] = pageindex.toString();
                        moduleObj['name'] = numOfPages === 1 ? `${moduleObj['name']}` : `${moduleObj['name']} ${i}`;
                        moduleObj['appPage'] = i;
                        roomDetails[roomId]['pages'][pageindex] =moduleObj;
                        pageindex++;
                    }
                //Adding counter-top instruction links
                addPDFLinks(instructionsTempleates["hdsServices"].countertop, instructionCatList, pdfLinks);
            }
            if(countertopElevationInfoList.length>0){
                let pageCount=1;
                countertopElevationInfoList.map(elevation=>{
                    let numOfPages = Math.ceil((elevation?.countertopSize || 1)/maxCounterTopTables);
                    for(var i=1; i<= numOfPages; i++){
                        let counterTop = cloneDeep(template['pages']['COUNTERTOP']);
                        //pageindex +=1;
                        counterTop['elevationId']=elevation?.elevationViewId;
                        counterTop['name']=`${counterTop['name']} ${pageCount}`;
                        counterTop['pageNumber'] = pageindex.toString();
                        counterTop['type']="COUNTERTOP_ELEVATION";
                        roomDetails[roomId]['pages'][pageindex] = counterTop;
                        pageindex +=1;
                        pageCount++;
                        counterTop['appPage'] = i;
                    }
                    return elevation;
                })
                //Adding counter-top instruction links
                addPDFLinks(instructionsTempleates["hdsServices"].countertop, instructionCatList, pdfLinks);
            }
            if(hasCountertop) {
                const counterTopMaterial = hdsServicesData_json?.filter(obj => obj?.hdsQuoteData?.second?.categoryId === 'COUNTER_TOP_MATERIAL')
                const counterTopInstallation = hdsServicesData_json?.filter(obj => obj?.hdsQuoteData?.second?.subCategory === 'Countertop Installation')
                const counterTopMaterialSow = {
                    material: counterTopMaterial?.reduce((sum, obj) => sum + obj?.hdsQuoteData?.second?.area, 0),
                    installation: counterTopInstallation?.reduce((sum, obj) => sum + obj?.hdsQuoteData?.second?.area, 0),
                };

                let moduleObj = cloneDeep(template['pages']['COUNTER_TOP_MATERIAL_SOW']);
                moduleObj['pageNumber'] = pageindex.toString();
                moduleObj['name'] = `${moduleObj['name']}`;
                moduleObj['isFirstPage'] = i > 1 ? false : true;
                moduleObj['counterTopMaterialSow'] = {
                    countertop_material_supply: {
                        scope: counterTopMaterialSow?.material ? 'Homelane' : 'Cx',
                        quantity: `Area: ${parseFloat(counterTopMaterialSow?.material?.toFixed(2))} ${counterTopMaterial?.[0]?.hdsQuoteData?.second?.uom || ''}`
                    },
                    countertop_installation: {
                        scope: counterTopMaterialSow?.installation ? 'Homelane' : 'Cx',
                        quantity: `Area: ${parseFloat(counterTopMaterialSow?.installation?.toFixed(2))} ${counterTopInstallation?.[0]?.hdsQuoteData?.second?.uom || ''}`
                    }
                };
                roomDetails[roomId]['pages'][pageindex] = moduleObj;
                pageindex++;
            }
            if(categorySubcategoryRoom && categorySubcategoryRoom.length){
                for(var inIndex =0; inIndex< categorySubcategoryRoom.length; inIndex++){
                    let category = categorySubcategoryRoom[inIndex];
                    let { subcategorySet, categoryName } = category;
                    if(subcategorySet && subcategorySet.length){
                        for(var subIndex =0; subIndex<subcategorySet.length; subIndex++){
                            let subCategory = subcategorySet[subIndex]
                            let pageIndexes = instructionsTempleates[categoryName?.toLowerCase()] ? instructionsTempleates[categoryName?.toLowerCase()][subCategory?.toLowerCase()] : [];
                            if(pageIndexes && pageIndexes.length){
                                pageIndexes.map(pageIn=>{
                                    instructionCatList.add(pdfLinks[pageIn-1])
                                    return pageIn;
                                })
                            }
                        }
                    }

                }
            }

            //Curtains Page Implementation
            if(curtainsData?.length>0){
                let pageCount=1;

                const groupByType = (arr) => {

                    return arr.reduce((acc, current) => {
                      const type = current?.hdsServiceData?.hdsQuoteData?.second?.brand;
                      if (!acc[type]) {
                        acc[type] = [];
                      }
                      acc[type].push(current);
                      return acc;
                    }, {});
                  };

                const groupByFixture = groupByType(curtainsData);
                
                Object.entries(groupByFixture).map(([key, value]) => {
                    groupByFixture?.[key]?.map((curtains: any) => {
                        const PageTypeName = key?.includes('Decor') ? 'CURTAINS_DECOR' : key?.includes('Aumbre') ? 'CURTAINS_AUMBRE' : key?.includes('Yellow') ? 'CURTAINS_YELLOW' : 'CURTAINS';
                        

                        let numOfPages = Math.ceil((groupByFixture?.[key]?.length)/2);
                        let curtainsSplit = splitArrayChunksBatch(groupByFixture?.[key], numOfPages, 2, 2);
                        
                        for(var i=1; i<= numOfPages; i++){
                            let curtainsPage = cloneDeep(template['pages'][PageTypeName]);
                            curtainsPage['name']=`${curtainsPage['name']}`;
                            curtainsPage['pageNumber'] = pageindex.toString();
                            curtainsPage['type']=curtainsPage['type'];
                            curtainsPage['curtainsDetails'] = [];
                            curtainsPage['images']=[];
                            curtainsSplit[i - 1]?.map((e, index) => {

                                const curtainsData = e?.hdsServiceData?.hdsQuoteData?.second;
                                const panelType = curtainsData?.subCategory?.split('-');

                                const getValueByName = (name) => {
                                    const foundItem = curtainsData?.fixtureInfo?.fieldData.find(item => item.fieldName === name);
                                    return foundItem ? foundItem.fieldValue : ''; // Return the value if found, otherwise null
                                };

                                curtainsPage['curtainsDetails'].push(
                                    {
                                        ['brand_' + index]: curtainsData?.brand,
                                        ['fabric_name_' + index]: curtainsData?.name || 'N/A',
                                        ['panel_type_' + index]: panelType?.[1] || 'N/A',
                                        ['lining_' + index]: getValueByName('Lining')  || 'N/A',
                                        ['panel_width_' + index]: getValueByName('Panel Width')  || 'N/A',
                                        ['panel_height_' + index]: getValueByName('Height')  || 'N/A',
                                        ['length_' + index]: getValueByName('Length') || getValueByName('Rod Length') || 'N/A',
                                        ['rod_colour_' + index]: getValueByName('Rod & Finial Color') || 'N/A',
                                        ['finial_design_' + index]: curtainsData?.name?.includes('Rod') ? curtainsData?.name?.split('-')?.pop() : 'N/A',
                                        ['type_' + index]: panelType?.[1] || 'N/A',
                                        ['hardware_type_' + index]: panelType?.[1]?.split(' ')?.pop() || 'N/A',
                                        ['header_style_' + index]: getValueByName('Header Type') || 'N/A',
                                        ['panel_name_' + index]: 'Panel Code:',
                                        ['quantity_' + index]: curtainsData?.fixtureInfo?.dc_curtains?.length ? `${curtainsData?.fixtureInfo?.dc_curtains?.length} x ${curtainsData?.fixtureInfo?.dc_curtains?.width}` : curtainsData?.quantity || 'N/A',
                                        ['wall_orientation_' + index]: curtainsData?.fixtureInfo?.caption || 'N/A',
                                        ['sku_code_' + index]: curtainsData?.hlSkuId || 'N/A',
                                        ['uom_' + index]: curtainsData?.uom || 'N/A',
                                        ['curtains_height_' + index]: curtainsData?.height || 'N/A',
                                        ['heading']: `${curtainsData?.subCategory} - ${curtainsData?.brand}` || 'Curtains Details',
                                        ['designType']: curtainsData?.fixtureInfo?.designType || '',
                                    }
                                )
                                curtainsPage['images'].push(curtainsData['imageUrl']);
                            })

                            // Function to get the value by name
                            roomDetails[roomId]['pages'][pageindex] = curtainsPage;
                            pageindex +=1;
                            pageCount++;
                        }
                        return curtains;
                    })
                })
            }
            
            // New Blank Page for Custom Armadio Wood Work
            if(customWoodWorkView && customWoodWorkView?.customWoodWorkMetaDataList?.length){
                console.log('customWoodWorkMetaDataList', customWoodWorkView);
                
                let numOfPages = customWoodWorkView?.customWoodWorkMetaDataList?.length;
                for (let i = 1; i <= numOfPages; i++) {
                    const name = customWoodWorkView?.customWoodWorkMetaDataList?.[i - 1]?.name
                    const subCategory = customWoodWorkView?.customWoodWorkMetaDataList?.[i - 1]?.subcategory
                    const approvalImageUrl = customWoodWorkView?.customWoodWorkMetaDataList?.[i - 1]?.approvalImageUrl
                    const moduleImage = customWoodWorkView?.customWoodWorkMetaDataList?.[i - 1]?.moduleImage
                    const freshServiceTicket = customWoodWorkView?.customWoodWorkMetaDataList?.[i - 1]?.freshServiceTicket
                    let pageImages: string[] = [];
                    if (moduleImage) {
                        if (isPdfUrl(moduleImage)) {
                            try {
                                pageImages = yield call(getPdfPagesAsImages, moduleImage);
                            } catch (err) {
                                console.error('Error converting PDF to images:', err);
                                pageImages = [moduleImage];
                            }
                        }
                    }

                    // Each PDF page (or single image) gets its own cloned page
                    const imagesToRender = pageImages.length > 0 ? pageImages : [null];
                    for (let j = 0; j < imagesToRender.length; j++) {
                        let customArmadioWoodWork = cloneDeep(template['pages']['CUSTOM_WOODWORK']);
                        customArmadioWoodWork['pageNumber'] = pageindex.toString();
                        customArmadioWoodWork['name'] = imagesToRender[j] ? `${name} ${j + 1}` : name;
                        customArmadioWoodWork['approvalImageUrl'] = approvalImageUrl;
                        customArmadioWoodWork['moduleImage'] = moduleImage;
                        customArmadioWoodWork['freshServiceTicket'] = freshServiceTicket;
                        if (imagesToRender[j]) {
                            customArmadioWoodWork['images'] = [{ imageUrl: imagesToRender[j] }];
                        } else if(approvalImageUrl) {
                            customArmadioWoodWork['images'] = [{ imageUrl: approvalImageUrl }];
                        }
                        roomDetails[roomId]['pages'][pageindex] = customArmadioWoodWork;
                        pageindex++;
                    }
                }
            }

            let isCivilPresent=false,isDemolitionPresent=false,isFalseCeilingPresent=false,isShowerCubiclesPresent=false, demolitionDetails=[], civilWorkDetails=[];
            if(hdsServicesData_json){
                hdsServicesData_json.map(hds =>{
                    if(hds?.hdsQuoteData?.first === 'Demolition'){
                        isDemolitionPresent =true;
                        demolitionDetails.push(hds?.hdsQuoteData?.second);
                    }
                    // if(hds?.hdsQuoteData?.first === 'False Ceiling'){
                    //     isFalseCeilingPresent = true;
                    // }
                    if(hds?.hdsQuoteData?.first === 'Civil'){
                        isCivilPresent =true;
                        civilWorkDetails.push(hds?.hdsQuoteData?.second);
                    }
                    if(hds?.hdsQuoteData?.first === 'Shower Cubicles' && roomType==='default'){
                        isShowerCubiclesPresent =true;
                    }
                    return hds;
                })
            }
            if(isDemolitionPresent){
                if(newPageView) {
                    let numOfPages = 1;
                    if (demolitionDetails.length > 1) {
                        numOfPages = numOfPages + Math.ceil((demolitionDetails.length - 1 || 1) / 1);
                    }
                    let demolitionData = splitArrayChunksBatch(demolitionDetails, numOfPages, 1, 1);
                    for (let i = 1; i <= numOfPages; i++) {
                        let demolitionPage = cloneDeep(template['pages']['DEMOLITION_ROOM']);
                        demolitionPage['pageNumber'] = pageindex.toString();
                        demolitionPage['demolitionDetails'] = demolitionData[i - 1];
                        roomDetails[roomId]['pages'][pageindex] = demolitionPage;
                        demolitionPage['name'] = numOfPages === 1 ? `${demolitionPage['name']}` : `${demolitionPage['name']} ${i}`;
                        pageindex++;
                    }
                } else {
                    let demolitionPage = cloneDeep(template['pages']['DEMOLITION']);
                    demolitionPage['pageNumber'] = pageindex.toString();
                    roomDetails[roomId]['pages'][pageindex] = demolitionPage;
                    pageindex++;
                }
            }
            if(isFalseCeilingPresent){
                let falseCeilingPage = cloneDeep(template['pages']['FALSECEILING']);
                falseCeilingPage['pageNumber'] = pageindex.toString();
                roomDetails[roomId]['pages'][pageindex] = falseCeilingPage;
                pageindex++;
            }
            if(isCivilPresent){
                if(newPageView) {
                    let numOfPages = 1;
                    if (civilWorkDetails.length > 1) {
                        numOfPages = numOfPages + Math.ceil((civilWorkDetails.length - 1 || 1) / 1);
                    }
                    let civilWorkData = splitArrayChunksBatch(civilWorkDetails, numOfPages, 1, 1);
                    for (let i = 1; i <= numOfPages; i++) {
                        let civilWorkPage = cloneDeep(template['pages']['CIVIL_WORK']);
                        civilWorkPage['pageNumber'] = pageindex.toString();
                        civilWorkPage['civilWorkDetails'] = civilWorkData[i - 1]
                        roomDetails[roomId]['pages'][pageindex] = civilWorkPage;
                        civilWorkPage['name'] = numOfPages === 1 ? `${civilWorkPage['name']}` : `${civilWorkPage['name']} ${i}`;
                        pageindex++;
                    }
                } else {
                    let civilWorkPage = cloneDeep(template['pages']['BESPOKE']);
                    civilWorkPage['pageNumber'] = pageindex.toString();
                    roomDetails[roomId]['pages'][pageindex] = civilWorkPage;
                    pageindex++;
                }
            }
            if(isShowerCubiclesPresent){
                let showerCubiclesPage = cloneDeep(template['pages']['SHOWERCUBICLES']);
                showerCubiclesPage['pageNumber'] = pageindex.toString();
                roomDetails[roomId]['pages'][pageindex] = showerCubiclesPage;
                pageindex++;
            }
            if(looseFurnitureJson){
                let {looseFurnitureItems} = looseFurnitureJson;
                let hlBedsPresent=false;
                if(looseFurnitureItems?.length>0){
                    addPDFLinks(instructionsTempleates["loose-furniture"]["hl-junior"], instructionCatList, pdfLinks);                    
                    addPDFLinks(instructionsTempleates[orderProfileType === "DOOWUP" ? "d-loose-furniture" : "loose-furniture"]["puja-unit"], instructionCatList, pdfLinks);
                }
                looseFurnitureItems?.map(lf => {
                    if(lf?.looseFurnitureCode?.includes('Beds')){
                        hlBedsPresent = true;
                    }
                } )
                if(hlBedsPresent){
                    addPDFLinks(instructionsTempleates["loose-furniture"]["hl-beds"], instructionCatList, pdfLinks);
                }
                
                looseFurnitureItems.sort((a,b) => (a?.productSkuId?.localeCompare(b?.productSkuId)));
                let numOfLooseFurniturePages = Math.ceil(looseFurnitureItems.length/8);
                let splittedLooseFurnitureData = splitArrayChunks(looseFurnitureItems,numOfLooseFurniturePages);
                for(let i =0 ; i< numOfLooseFurniturePages;i++){
                    let looseFurniturePage = cloneDeep(template['pages']['LOOSE_FURNITURE']);
                    looseFurniturePage['pageNumber'] = pageindex.toString();
                    looseFurniturePage['name'] = numOfLooseFurniturePages === 1 ? `${looseFurniturePage['name']}` : `${looseFurniturePage['name']} ${i+1}`;
                    looseFurniturePage['appPage'] = i;
                    looseFurniturePage['looseFurnitureList'] = splittedLooseFurnitureData[i];
                    roomDetails[roomId]['pages'][pageindex] = looseFurniturePage;
                    pageindex++;
                }
            }
            // Module List pages
            let {zones} = modules_response;
            let modulesList = [];  
            zones?.map(zone => {
                    modulesList.push(...zone['modules']);
             })
            let numOfPages=1;
            if (modulesList.length > 0) {
                //    let numberForSplits =Math.ceil(modulesList.length/maxRowsModuleList);
                //    let splitArray = splitArrayChunks(modulesList, numberForSplits);
                let splitArray = [];
                const max_lines = 560; // Height of the container in pixel.
                while (true) {
                    let pindex = 0; // Page index
                    let rem_lines = max_lines;
                    let prev_zone = modulesList[0]['zoneObjectId'];
                    modulesList?.map(module => {
                        let no_excess_acc = 0, no_excess_handles = 0, name_length = 40;

                        //Checking the length of the accessory.
                        if (module?.accessoryPayload?.length) {
                            let originalLength = 0;

                            //Filter the duplicate/Null value from accessory.
                            const filterArray = module?.accessoryPayload?.map((e) => {
                                if(e?.name) {
                                   const name = `${e?.name} | ${e?.softClose?"SOFT CLOSE":"NON-SOFT CLOSE"}`
                                   originalLength += name.length > 54 ? 50 : 40;
                                }
                            });
                            
                            //Updating the accessory length
                            no_excess_acc = originalLength
                            
                        }

                        //Handle value updating if profileType is G_PROFILE.
                        if(['GOLA', "G_PROFILE"].includes(module?.profileType )) {
                            module['handle'] = [{ name: module?.handleProfile?.name }]
                        }

                        //Checking the length of the handle.
                        if (module?.handle?.length) {
                           const originalLength = [...new Set(module?.handle?.map(h => (h?.name || "")))]
                            //Updating the handle length
                            no_excess_handles = 40 * originalLength.length
                        }

                        // Creating a name string which is used in UI (To find the original length)
                        let name = `${module?.moduleName} | ${module?.softClose ? `SOFT CLOSE | ${module?.softCloseType} | ${module?.softCloseMake !== "NA" ? module?.softCloseMake : ""}` : "NON-SOFT CLOSE"}`;

                        // Check name is adjusting in 1/3 lines
                        if (name?.length < 47 || name?.length > 95) {
                            name_length = name?.length > 95 ? 60 : 26
                        }

                        let req_lines = Math.max(no_excess_acc, no_excess_handles, name_length);
                        

                        if (module?.zoneObjectId !== prev_zone) {
                            prev_zone = module.zoneObjectId;
                            rem_lines = rem_lines - 100;
                        }

                        if (rem_lines >= req_lines) {
                            if (!splitArray[pindex]) {
                                splitArray[pindex] = [];
                            }
                            splitArray[pindex].push(module);
                            rem_lines = rem_lines - req_lines;
                        }
                        else {
                            rem_lines = max_lines;
                            pindex++;
                            if (!splitArray[pindex]) {
                                splitArray[pindex] = [];
                            }
                            splitArray[pindex].push(module);
                            rem_lines = rem_lines - req_lines;
                        }

                    });
                    break;
                }

                splitArray?.map((chunk, index) => {
                    splitted_modules[index] = chunk;
                })

                numOfPages = splitArray.length;
            }
            for(let i=1; i<= numOfPages; i++){
                let moduleObj = cloneDeep(template['pages']['MODULELIST']);
                moduleObj['pageNumber'] = pageindex.toString();
                moduleObj['name'] = numOfPages === 1 ? `${moduleObj['name']}` : `${moduleObj['name']} ${i}`;
                moduleObj['appPage'] = i;
                roomDetails[roomId]['pages'][pageindex] =moduleObj;
                pageindex++;
            }
            if(other_services_response && !other_services_response.error){
                let otherServicesPage = cloneDeep(template['pages']['OTHER_SERVICES']);
                let otherServicesArray = [];
                Object.keys(other_services_response)?.map(key => {
                    if(other_services_response[key]){
                        otherServicesArray.push({'service_name':key,'homelane_scope':"Yes"})
                    }
                    else{
                        otherServicesArray.push({'service_name':key,'homelane_scope':"NA"})
                    }
                })
                otherServicesPage['pageNumber'] = pageindex.toString();
                otherServicesPage['otherServices'] = otherServicesArray;
                roomDetails[roomId]['pages'][pageindex] = otherServicesPage;
                pageindex++;
            }

            if (hdsSequenceData?.length) {
                function deepMerge(obj1, obj2) {
                    for (const key in obj2) {
                      const value1 = obj1[key];
                      const value2 = obj2[key];
                  
                      // If obj2[key] is null, retain obj1[key]
                      if (value2 === null) {
                        continue; // Skip overwriting with null
                      }
                      // If obj1[key] is null, assign obj2[key]
                      else if (value1 === null) {
                        obj1[key] = value2;
                      }
                      // If both are arrays, concatenate their elements
                      else if (Array.isArray(value1) && Array.isArray(value2)) {
                        obj1[key] = [...value1, ...value2];
                      }
                      // If both are objects, merge them recursively
                      else if (isObject(value1) && isObject(value2)) {
                        deepMerge(value1, value2);
                      }
                      // If obj1[key] doesn't exist, assign obj2[key]
                      else if (value1 === undefined) {
                        obj1[key] = value2;
                      }
                      // If both values are primitives, replace with obj2's value
                      else {
                        obj1[key] = value2;
                      }
                    }
                    return obj1; // Return the modified obj1
                  }
                  
                  function isObject(value) {
                    return value && typeof value === 'object' && !Array.isArray(value);
                  }
                  
                  
                deepMerge(falseCeilingData, hdsSequenceData?.[0]?.falseCeilingData);
            }            

            // Checking if new generate Quote the show new FC pages 
            if (newPageView) {
                let showScopeOfWorkPage = false;
                let LightingDetails = [];
                

                // Function to remove duplicate objects based on 'name' property
                const removeDuplicates = (arr, prop) => {
                    if (arr?.length) {
                        const uniqueObjects = Object.values(arr.reduce((acc, { product_name, area, ...rest }) => {
                            acc[product_name] = acc[product_name] || { product_name, area: '0 SQFT', ...rest };
                            acc[product_name].area = (parseFloat(acc[product_name].area) + parseFloat(area)).toFixed(2) + ' SQFT';
                            return acc;
                          }, {}));
                         return uniqueObjects 
                    }
                    return []
                      
                };
                let { falseCeilingOverview, falseCeilingLightingView } = falseCeilingData;
                // if (falseCeilingOverview?.metaData?.lightFixtures?.length) {
                    const lightFixturesDetails = falseCeilingOverview?.metaData?.lightFixtures || falseCeilingLightingView?.metaData?.falseCeilingLightingData || []
                    LightingDetails = gettingLightingType(lightFixturesDetails);
                // }

                if (falseCeilingData?.falseCeilingView || (falseCeilingData?.paintFalseCeilingView && falseCeilingData?.paintFalseCeilingView?.metaData)) {
                    let { paintFalseCeilingView, falseCeilingView, reflectedFalseCeilingView } = falseCeilingData
                    let numOfPages = 2;
                    showScopeOfWorkPage = true;
                    const paintDetails = removeDuplicates(paintFalseCeilingView?.metaData?.paintDetails, 'product_name');
                    const imageDetails = splitArrayChunksBatch(falseCeilingView?.imageData, numOfPages, 2, 2);
                    if (paintDetails.length > 4) {
                        numOfPages = numOfPages + Math.ceil((paintDetails.length - 4 || 1) / maxFalseCeilingOverviewLights);
                    }
                    let paintData = paintDetails?.length ? splitArrayChunksBatch(paintDetails, numOfPages, 4, maxFalseCeilingOverviewLights) : '';
                    for (let i = 1; i <= numOfPages; i++) {
                        let moduleObj = cloneDeep(template['pages']['CUSTOM_FALSECEILING_OVERVIEW']);
                        moduleObj['pageNumber'] = pageindex.toString();
                        moduleObj['name'] = numOfPages === 1 ? `${moduleObj['name']}` : `${moduleObj['name']} ${i}`;
                        moduleObj['paintDetails'] = paintData ? paintData[i - 1] : ''
                        moduleObj['images'] = imageDetails[i-1];
                        moduleObj['fc_type'] = reflectedFalseCeilingView?.metaData?.type;
                        moduleObj['isFirstPage'] = i > 1 ? false : true
                        roomDetails[roomId]['pages'][pageindex] = moduleObj;
                        pageindex++;
                    }
                }

                if (falseCeilingData?.reflectedFalseCeilingView) {
                    let { reflectedFalseCeilingView } = falseCeilingData
                    let numOfPages = 1;
                    
                    const findFalseCeilingService = hdsServicesData_json.filter((e) => e?.hdsQuoteData?.first?.includes('False Ceiling'));

                    const horizontalPanel = findFalseCeilingService?.reduce((sum, obj) => obj?.hdsQuoteData?.second?.name?.includes('Horizontal') ? sum + obj.hdsQuoteData?.second?.area : sum, 0);
                    const verticalPanel = findFalseCeilingService?.reduce((sum, obj) => obj?.hdsQuoteData?.second?.name?.includes('Vertical Panel upto') ? sum + obj.hdsQuoteData?.second?.length : sum, 0);
                    const verticalPanelWithCove = findFalseCeilingService?.reduce((sum, obj) => obj?.hdsQuoteData?.second?.name?.includes('Vertical Panel With Cove') ? sum + obj.hdsQuoteData?.second?.length : sum, 0);
                    const quantityDetails = {
                        horizontal_panel: horizontalPanel?.toFixed(0),
                        vertical_panel: verticalPanel?.toFixed(0),
                        vertical_with_cove: verticalPanelWithCove?.toFixed(0),
                    }
                    
                    showScopeOfWorkPage = true;
                    for (let i = 1; i <= numOfPages; i++) {
                        let moduleObj = cloneDeep(template['pages']['CUSTOM_FALSECEILING_PLAN']);
                        moduleObj['pageNumber'] = pageindex.toString();
                        moduleObj['name'] = numOfPages === 1 ? `${moduleObj['name']}` : `${moduleObj['name']} ${i}`;
                        moduleObj['images'] = reflectedFalseCeilingView.imageData;
                        moduleObj['quantityDetails'] = quantityDetails;
                        moduleObj['isFirstPage'] = i > 1 ? false : true;
                        roomDetails[roomId]['pages'][pageindex] = moduleObj;
                        pageindex++;
                    }
                }

                if (falseCeilingData?.crossSectionFalseCeilingView) {
                    let { crossSectionFalseCeilingView } = falseCeilingData;
                    showScopeOfWorkPage = true;
                    if (crossSectionFalseCeilingView?.imageData?.length > 0) {
                        let numOfPages = 1;
                        let imageChunkSplit = splitArrayChunks(crossSectionFalseCeilingView.imageData, numOfPages);
                        for (let i = 1; i <= numOfPages; i++) {
                            let moduleObj = cloneDeep(template['pages']['CUSTOM_FALSECEILING_SECTION']);
                            moduleObj['pageNumber'] = pageindex.toString();
                            moduleObj['name'] = numOfPages === 1 ? `${moduleObj['name']}` : `${moduleObj['name']} ${i}`;
                            // moduleObj['metaData']= crossSectionFalseCeilingView.metaData
                            moduleObj['images'] = imageChunkSplit[i - 1]
                            roomDetails[roomId]['pages'][pageindex] = moduleObj;
                            pageindex++;
                        }
                    }
                }

                if (falseCeilingData?.reflectedFalseCeilingView) {
                    let { falseCeilingLightingView } = falseCeilingData;
                    
                    let falseCeilingLight = lightingItemsDetails?.lightingItems?.filter((e) => e?.subcategory === 'False Ceiling');;
                    let numOfPages = Math.ceil(falseCeilingLight?.length / 8);;
                    showScopeOfWorkPage = true;

                    let lightData = splitArrayChunksBatch(falseCeilingLight, numOfPages, 8, 8);
                    for (let i = 1; i <= numOfPages; i++) {
                        let moduleObj = cloneDeep(template['pages']['CUSTOM_FALSECEILING_ELECTRICAL_SOW']);
                        moduleObj['pageNumber'] = pageindex.toString();
                        moduleObj['name'] = numOfPages === 1 ? `${moduleObj['name']}` : `${moduleObj['name']} ${i}`;
                        moduleObj['lightingDetails'] = lightData[i - 1]
                        moduleObj['images'] = falseCeilingLightingView?.imageData
                        moduleObj['isFirstPage'] = i > 1 ? false : true
                        roomDetails[roomId]['pages'][pageindex] = moduleObj;
                        pageindex++;
                    }

                }

                if (falseCeilingData?.falseCeilingLightingView && falseCeilingData?.falseCeilingOverview) {
                    let { falseCeilingLightingView, falseCeilingOverview } = falseCeilingData;
                    let numOfPages = Math.ceil((falseCeilingOverview?.metaData?.lightFixtures.length || 1) / 4);
                    let lighingSplitChunk = splitArrayChunks(falseCeilingOverview?.metaData?.lightFixtures, numOfPages);
                    showScopeOfWorkPage = true;
                    for (let i = 1; i <= numOfPages; i++) {
                        let moduleObj = cloneDeep(template['pages']['CUSTOM_FALSECEILING_LIGHT_LAYOUT']);
                        moduleObj['pageNumber'] = pageindex.toString();
                        moduleObj['name'] = numOfPages === 1 ? `${moduleObj['name']}` : `${moduleObj['name']} ${i}`;
                        moduleObj['images'] = falseCeilingLightingView?.imageData
                        moduleObj['isFirstPage'] = i > 1 ? false : true
                        roomDetails[roomId]['pages'][pageindex] = moduleObj;
                        moduleObj['lightingDetails'] = LightingDetails;
                        moduleObj['lightFixtures'] = lighingSplitChunk[i-1];
                        pageindex++;
                    }
                }

                if (falseCeilingData?.falseCeilingElectricalLoopingView) {
                    let { falseCeilingElectricalLoopingView } = falseCeilingData;
                    showScopeOfWorkPage = true;
                    const pointEntitiesArray = [];
                    const findFalseCeilingLightService = hdsServicesData_json.filter((e) => ['Lighting', 'Electrical services'].includes(e?.hdsQuoteData?.first));
                    const pointEntitiesDetails =  findFalseCeilingLightService?.map((e) => e?.visualEntity?.pointEntities?.length ? pointEntitiesArray?.push(...e?.visualEntity?.pointEntities) : '');                    

                    if (falseCeilingElectricalLoopingView.imageData.length > 0) {
                        let numOfPages = Math.ceil((falseCeilingElectricalLoopingView.imageData.length || 1) / 1);
                        let imageChunkSplit = splitArrayChunks(falseCeilingElectricalLoopingView.imageData, numOfPages);
                        for (let i = 1; i <= numOfPages; i++) {
                            let moduleObj = cloneDeep(template['pages']['CUSTOM_FALSECEILING_LOOPING_LAYOUT']);
                            moduleObj['pageNumber'] = pageindex.toString();
                            moduleObj['name'] = numOfPages === 1 ? `${moduleObj['name']}` : `${moduleObj['name']} ${i}`;
                            moduleObj['images'] = imageChunkSplit[i - 1];
                            moduleObj['loopedDetails'] = pointEntitiesArray;
                            roomDetails[roomId]['pages'][pageindex] = moduleObj;
                            pageindex++;
                        }
                    }
                }

                if (showScopeOfWorkPage) {
                    let numOfPages = 1;
                    for (let i = 1; i <= numOfPages; i++) {
                        let moduleObj = cloneDeep(template['pages']['CUSTOM_SCOPE_OF_WORK_TABLE']);
                        moduleObj['pageNumber'] = pageindex.toString();
                        moduleObj['name'] = `${moduleObj['name']}`;
                        moduleObj['isFirstPage'] = i > 1 ? false : true
                        roomDetails[roomId]['pages'][pageindex] = moduleObj;
                        pageindex++;
                    }
                }
            } else {

            if(falseCeilingData?.falseCeilingOverview){
                let {falseCeilingOverview} = falseCeilingData
                let numOfPages = 1
                if(falseCeilingOverview.metaData.lightFixtures.length>4){
                    numOfPages = numOfPages+ Math.ceil((falseCeilingOverview.metaData.lightFixtures.length - 4 || 1)/maxFalseCeilingOverviewLights);
                }
                let lightData = splitArrayChunksBatch(falseCeilingOverview.metaData.lightFixtures, numOfPages, 4, maxFalseCeilingOverviewLights);
                for(let i=1;i<=numOfPages;i++){
                    let moduleObj = cloneDeep(template['pages']['FALSECEILING_OVERVIEW']);
                    moduleObj['pageNumber'] = pageindex.toString();
                    moduleObj['name'] = numOfPages === 1 ? `${moduleObj['name']}` : `${moduleObj['name']} ${i}`;
                    moduleObj['metaData']={ 
                                            "falseCeilingDetails" : falseCeilingOverview.metaData.falseCeilingDetails,
                                            "lightFixtures" : lightData[i-1]
                                        }
                    moduleObj['images']= falseCeilingOverview.imageData
                    moduleObj['isFirstPage'] = i>1 ? false : true
                    roomDetails[roomId]['pages'][pageindex] =moduleObj;
                    pageindex++;
                }
            }
            if(falseCeilingData?.falseCeilingView){
                let {falseCeilingView} = falseCeilingData
                let numOfPages = Math.ceil((falseCeilingView.imageData.length || 1)/maxFalseCeilingPlanImages);
                let imageChunkSplit = splitArrayChunks(falseCeilingView.imageData, numOfPages);
                for(let i=1;i<=numOfPages;i++){
                    let moduleObj = cloneDeep(template['pages']['FALSECEILING_PLANVIEW']);
                    moduleObj['pageNumber'] = pageindex.toString();
                    moduleObj['name'] = numOfPages === 1 ? `${moduleObj['name']}` : `${moduleObj['name']} ${i}`;
                    moduleObj['metaData']= falseCeilingView.metaData
                    moduleObj['images']= imageChunkSplit[i-1]
                    roomDetails[roomId]['pages'][pageindex] =moduleObj;
                    pageindex++;
                }
            }
            if(falseCeilingData?.reflectedFalseCeilingView){
                let {reflectedFalseCeilingView} = falseCeilingData
                let numOfPages = 1
                if(reflectedFalseCeilingView.metaData.lights.length>10){
                    numOfPages = numOfPages+ Math.ceil((reflectedFalseCeilingView.metaData.lights.length - 10 || 1)/maxFalseCeilingReflectedLights);
                }
                let lightData = splitArrayChunksBatch(reflectedFalseCeilingView.metaData.lights, numOfPages, 10, maxFalseCeilingReflectedLights);
                for(let i=1;i<=numOfPages;i++){
                    let moduleObj = cloneDeep(template['pages']['FALSECEILING_REFLECTEDVIEW']);
                    moduleObj['pageNumber'] = pageindex.toString();
                    moduleObj['name'] = numOfPages === 1 ? `${moduleObj['name']}` : `${moduleObj['name']} ${i}`;
                    moduleObj['metaData']=  { "lights" : lightData[i-1], "type": i == 1 ? reflectedFalseCeilingView?.metaData?.type :''}
                    moduleObj['images']= reflectedFalseCeilingView.imageData
                    moduleObj['isFirstPage'] = i>1 ? false : true
                    roomDetails[roomId]['pages'][pageindex] =moduleObj;
                    pageindex++;
                }
            }
            if(falseCeilingData?.falseCeilingLightingView){
                let {falseCeilingLightingView} = falseCeilingData;
                let numOfPages = 1;
                if(falseCeilingLightingView.metaData.falseCeilingLightingData.length>10){
                    numOfPages = numOfPages+ Math.ceil((falseCeilingLightingView.metaData.falseCeilingLightingData.length - 8 || 1)/maxFalseCeilingReflectedLights);
                }
                let lightData = splitArrayChunksBatch(falseCeilingLightingView.metaData.falseCeilingLightingData, numOfPages, 8, maxFalseCeilingReflectedLights);
                for(let i=1;i<=numOfPages;i++){
                    let moduleObj = cloneDeep(template['pages']['FALSECEILING_LIGHTINGVIEW']);
                    moduleObj['pageNumber'] = pageindex.toString();
                    moduleObj['name'] = numOfPages === 1 ? `${moduleObj['name']}` : `${moduleObj['name']} ${i}`;
                    moduleObj['metaData']=  { "falseCeilingLightingData" : lightData[i-1] }
                    moduleObj['images']=  falseCeilingLightingView.imageData
                    moduleObj['isFirstPage'] = i>1 ? false : true
                    roomDetails[roomId]['pages'][pageindex] =moduleObj;
                    pageindex++;
                }

            }
            if(falseCeilingData?.falseCeilingElectricalView){
                let {falseCeilingElectricalView} = falseCeilingData;
                let numOfPages = 1;
                if(falseCeilingElectricalView.metaData.falseCeilingElectricalData.length>5){
                    numOfPages = numOfPages+ Math.ceil((falseCeilingElectricalView.metaData.falseCeilingElectricalData.length - 5 || 1)/5);
                }
                let electicalData = splitArrayChunksBatch(falseCeilingElectricalView.metaData.falseCeilingElectricalData, numOfPages, 5, 5);
                for(let i=1;i<=numOfPages;i++){
                    let moduleObj = cloneDeep(template['pages']['FALSECEILING_ELECTRICALVIEW']);
                    moduleObj['pageNumber'] = pageindex.toString();
                    moduleObj['name'] = numOfPages === 1 ? `${moduleObj['name']}` : `${moduleObj['name']} ${i}`;
                    moduleObj['metaData']=  { "falseCeilingElectricalData" : electicalData[i-1] }
                    moduleObj['images']=  falseCeilingElectricalView.imageData
                    moduleObj['isFirstPage'] = i>1 ? false : true
                    roomDetails[roomId]['pages'][pageindex] =moduleObj;
                    pageindex++;
                }

            }
            
            if(falseCeilingData?.falseCeilingElectricalLoopingView){
                let {falseCeilingElectricalLoopingView} = falseCeilingData;
                if(falseCeilingElectricalLoopingView.imageData.length > 0){
                    let numOfPages = Math.ceil((falseCeilingElectricalLoopingView.imageData.length || 1)/1);
                    let imageChunkSplit = splitArrayChunks(falseCeilingElectricalLoopingView.imageData, numOfPages);
                    for(let i=1;i<=numOfPages;i++){
                        let moduleObj = cloneDeep(template['pages']['FALSECEILING_ELECTRICAL_LOOPINGVIEW']);
                        moduleObj['pageNumber'] = pageindex.toString();
                        moduleObj['name'] = numOfPages === 1 ? `${moduleObj['name']}` : `${moduleObj['name']} ${i}`;
                        moduleObj['metaData']= falseCeilingElectricalLoopingView.metaData
                        moduleObj['images']= imageChunkSplit[i-1]
                        roomDetails[roomId]['pages'][pageindex] =moduleObj;
                        pageindex++;
                    }
                }
            }

            if(falseCeilingData?.crossSectionFalseCeilingView){
                let {crossSectionFalseCeilingView} = falseCeilingData
                if(crossSectionFalseCeilingView.imageData.length > 0){
                    let numOfPages = Math.ceil((crossSectionFalseCeilingView.imageData.length || 1)/maxFalseCeilingSectionImages);
                    let imageChunkSplit = splitArrayChunks(crossSectionFalseCeilingView.imageData, numOfPages);
                    for(let i=1;i<=numOfPages;i++){
                        let moduleObj = cloneDeep(template['pages']['FALSECEILING_SECTIONVIEW']);
                        moduleObj['pageNumber'] = pageindex.toString();
                        moduleObj['name'] = numOfPages === 1 ? `${moduleObj['name']}` : `${moduleObj['name']} ${i}`;
                        moduleObj['metaData']= crossSectionFalseCeilingView.metaData
                        moduleObj['images']= imageChunkSplit[i-1]
                        roomDetails[roomId]['pages'][pageindex] =moduleObj;
                        pageindex++;
                    }
                }
            }
            
            if(falseCeilingData?.paintFalseCeilingView && falseCeilingData?.paintFalseCeilingView.metaData){
                let {paintFalseCeilingView} = falseCeilingData
                let numOfPages = 1
                if(paintFalseCeilingView.metaData.paintDetails.length>4){
                    numOfPages = numOfPages+ Math.ceil((paintFalseCeilingView.metaData.paintDetails.length - 4 || 1)/maxFalseCeilingOverviewLights);
                }
                let paintData = splitArrayChunksBatch(paintFalseCeilingView.metaData.paintDetails, numOfPages, 4, maxFalseCeilingOverviewLights);
                for(let i=1;i<=numOfPages;i++){
                    let moduleObj = cloneDeep(template['pages']['FALSECEILING_PAINTVIEW']);
                    moduleObj['pageNumber'] = pageindex.toString();
                    moduleObj['name'] = numOfPages === 1 ? `${moduleObj['name']}` : `${moduleObj['name']} ${i}`;
                    moduleObj['metaData']= { "paintDetails" : paintData[i-1] }
                    moduleObj['images']= paintFalseCeilingView.imageData
                    moduleObj['isFirstPage'] = i>1 ? false : true
                    roomDetails[roomId]['pages'][pageindex] =moduleObj;
                    pageindex++;
                }
            }
            }

            // RFQ Pages Addition
            if (rfqDetails?.products?.length > 0) {
                let pageCount = 1;
                rfqDetails?.products.map((value, key) => {
                    value?.attachments?.map((rfqDetails: any, innerKey: any) => {
                        const index = value?.attachments?.length > 1 ? innerKey + 1 : '';
                            let RFQPage = cloneDeep(template['pages']['RFQ']);                          
                            RFQPage['name'] = `${RFQPage['name']} ${value['seq'] ? `SEQ-${value['seq']}` : key + 1 }${index ? '.' + index : ''} (${value?.subCategoryName})`;
                            RFQPage['pageNumber'] = pageindex.toString();
                            RFQPage['type'] = RFQPage['type'];
                            RFQPage['rfqDetails'] = value;
                            RFQPage['images'] = rfqDetails;
                            RFQPage['reviewed'] = true;

                            // Function to get the value by name
                            roomDetails[roomId]['pages'][pageindex] = RFQPage;
                            pageindex += 1;
                            pageCount++;
                        return rfqDetails;
                    })
                })
            }        
            
            // DQC comments pages addition
            if (dqcCommentsData && dqcCommentsData.length > 0) {
                const max_height = 560; // Total page height in pixels
                let current_height = 0;
                let dqcItems = [];
                let currentItem = [];

                dqcCommentsData.forEach((item,index) => {
                    // Estimate the height of the current comment block
                    // Fixed height for headers ("DQC Error:", "Comment:") and margins/padding ~ 60px
                    // Line height is ~10px, approx 60 characters fit in one line
                    const errorLines = Math.ceil((item.designErrorText?.length || 0) / 60) || 1;
                    const commentLines = Math.ceil((item.exceptionReasoning?.length || 0) / 60) || 1;
                    const row_length = errorLines > commentLines ? errorLines : commentLines;
                    const itemHeight = 40 + (row_length) * 10;

                    if (current_height + itemHeight > max_height && currentItem.length > 0) {
                        dqcItems.push(currentItem);
                        currentItem = [item];
                        current_height = itemHeight;
                    } else {
                        currentItem.push(item);
                        current_height += itemHeight;
                    }
                });

                if (currentItem.length > 0) {
                    dqcItems.push(currentItem);
                }

                dqcItems.forEach((item, index) => {
                    let DQCPage = cloneDeep(template['pages']['DQC']);
                    DQCPage['name'] = dqcItems.length === 1 ? "Bypassed System Design Errors" : `Bypassed System Design Errors ${index + 1}`;
                    DQCPage['pageNumber'] = pageindex.toString();
                    DQCPage['dqcComments'] = item;
                    DQCPage['reviewed'] = true;

                    roomDetails[roomId]['pages'][pageindex] = DQCPage;
                    pageindex += 1;
                });
            }
            
            let orderProfileTypeSaga = yield select(orderProfileSelector);
            if(instructionCatList && instructionCatList.size && !['designcafe', 'dc']?.includes(orderProfileTypeSaga?.toLowerCase())) {
                let instructionObj = {
                    "name": "Instruction Page",
                    "type": "instruction",
                    "image": "",
                    "pageNumber": pageindex,
                    "reviewed": false,
                    "links": []
                }
                instructionCatList.forEach(link=>{
                    instructionObj.links?.push(link)
                })
                
                roomDetails[roomId]['pages'][pageindex] = instructionObj;
            }
            if(roomDetails){
                const projectId = `${opportunityId}_${version}`;
                const getPages = yield fetchDrawingApi(`pages/project/${projectId}/room/${roomId}`);
                const response = yield getPages.json();
                if(response && !response.error){
                    
                    const {pages} = response;
                    let newPages = {}, newList =[];
                    //let newPageList=[];
                    if(pages && pages.length){
                        let tempPages = roomDetails[roomId]['pages'];

                        let pagesArray = Object.values(tempPages) || [];
                        let overViewPage = pagesArray.filter(p=>{
                            if(p['pageType'] === 'overview'){
                                return true;
                            }
                            return false;
                        });
                        /*
                         * Page Ordering logic 
                        pages.map( function( item ) {
                            if(item.pageType == "created_page")
                                newList.push(item);
                            for( var i=0, len= pagesArray.length; i<len; i++ ){
                                if( pagesArray[i]['name'] == item.name) {
                                    let templateObj = Object.assign({},item);
                                    item = pagesArray[i];
                                    item['pageNumber'] = templateObj['pageNumber'];
                                    item['reviewed'] = templateObj['reviewed'];
                                    item['notes'] = templateObj['notes'];
                                    item['drawing'] = templateObj['drawing'];
                                    item['annotations'] = templateObj['annotations'];
                                    item['measurement'] = templateObj['measurement'];
                                    newList.push(item);
                                }
                            }
                        });
                        const diffPage = pagesArray.filter((elem) => !newList.find(({ name }) => elem['name'] === name));
                        (diffPage || []).map((page, index)=>{
                            newList.push(page);
                        });
                        newList = maintainElevationId(newList, pagesArray);*/
                        let NonMatchingNewPages = [];
                        let flagArray=[];
                        pages.map(oldPage => {
                            flagArray.push(false);
                            return oldPage;
                        })
                        pagesArray.map( function( item ) {
                            let found = false;
                            for( var i=0, len= pages.length; i<len; i++ ){
                                
                                const clean = (str) => str?.replace(/\s*\[[^\]]*\]\s*/g, '')?.trim();

                                if (pages[i]['name'] === item['name'] || clean(item['name']) === clean(pages[i]['name'])) {
                                    flagArray[i] = true;
                                    found = true;
                                    let templateObj = pages[i];

                                     //item['pageNumber'] = templateObj['pageNumber'];
                                    if (!['RFQ', 'DQC'].includes(item['pageType'])) {
                                        item['reviewed'] = templateObj['reviewed'];
                                    }
                                    else {
                                        item['reviewed'] = true;
                                    }
                                    item['notes'] = item["notes"] || templateObj['notes'];
                                    item['drawing'] = templateObj['drawing'];
                                    item['annotations'] = templateObj['annotations'];
                                    item['measurement'] = templateObj['measurement'];
                                    item['isOptional'] = templateObj['isOptional'];
                                    if(CustomerFalseCeilingTypes?.includes(item['type'])) {
                                        item['metaData'] = templateObj['metaData']
                                    }
                                }
                            }
                            if(!found){
                                NonMatchingNewPages.push(item);
                            }
                            newList.push(item);
                            return item;
                        });
                        let foundMatchingOldPages =false;
                        flagArray.map(flag => {
                            if(flag===false){
                                foundMatchingOldPages=true;
                            }
                            return flag;
                        })
                        if(foundMatchingOldPages){
                        NonMatchingNewPages?.map(newPage => {
                          pages?.map((oldPage,index) => {
                                if(flagArray[index]===false ){
                                    if((roomType==='kitchen' && (newPage['name']?.includes("wall") ? newPage['name']?.includes(oldPage['name']?.replace(/ *\[[^)]*\] */g,'')?.split("-")[1]):(newPage['name']?.includes(oldPage['name']?.split("-")[2]?.replace(/ *\[[^)]*\] */g,'')) && newPage['name']?.includes(oldPage['name']?.split("-")[0]))))){
                                        let templateObj = oldPage;
                                        //item['pageNumber'] = templateObj['pageNumber'];
                                        if (!['RFQ', 'DQC'].includes(newPage['pageType'])) {
                                            newPage['reviewed'] = templateObj['reviewed'];
                                        }
                                        else {
                                            newPage['reviewed'] = true;
                                        }
                                        newPage['notes'] = newPage["notes"] || templateObj['notes'];
                                        newPage['drawing'] = templateObj['drawing'];
                                        newPage['annotations'] = templateObj['annotations'];
                                        newPage['measurement'] = templateObj['measurement'];
                                        newPage['isOptional'] = templateObj['isOptional'];
                                        flagArray[index]=true;
                                    }
                                    else if(roomType==='default' && newPage['name']?.includes(oldPage['name']?.replace(/ *\[[^)]*\] */g,'')?.split("-")[2]) && newPage['name']?.includes(oldPage['name']?.split("-")[0]))
                                    {
                                        let templateObj = oldPage;
                                        //item['pageNumber'] = templateObj['pageNumber'];
                                        if (!['RFQ', 'DQC'].includes(newPage['pageType'])) {
                                            newPage['reviewed'] = templateObj['reviewed'];
                                        }
                                        else {
                                            newPage['reviewed'] = true;
                                        }
                                        newPage['notes'] = newPage["notes"] || templateObj['notes'];
                                        newPage['drawing'] = templateObj['drawing'];
                                        newPage['annotations'] = templateObj['annotations'];
                                        newPage['measurement'] = templateObj['measurement'];
                                        newPage['isOptional'] = templateObj['isOptional'];
                                        flagArray[index]=true;
                                    }
                                    
                                }
                          })
                        })
                        NonMatchingNewPages?.map(p => {
                            pagesArray?.map(item => {
                                if(p['pageNumber']===item['pageNumber']){
                                    let templateObj = p;
                                    if (!['RFQ', 'DQC'].includes(item['pageType'])) {
                                        item['reviewed'] = templateObj['reviewed'];
                                    }
                                    else {
                                        item['reviewed'] = true;
                                    }
                                    item['notes'] = item["notes"] || templateObj['notes'];
                                    item['drawing'] = templateObj['drawing'];
                                    item['annotations'] = templateObj['annotations'];
                                    item['measurement'] = templateObj['measurement'];
                                    item['isOptional'] = templateObj['isOptional'];
                                }
                            })
                        })
                        }
                        const diffPage = pages.filter((elem)  => elem['pageType'] === 'created_page');
                        (diffPage || []).map((page, index)=>{
                            newList.push(page);
                            return page;
                        });
                        pages?.map((oldPage,i)=>{
                            if(flagArray[i]===false && oldPage?.pageType!=='created_page'){
                                if(!oldPage['name']?.includes('OLD PAGE')){
                                    oldPage['name'] = oldPage['name']+"[OLD PAGE]";
                                }
                                newList.push(oldPage);
                            }
                            return oldPage;   
                        });    
                        (newList || []).map((page, index)=>{
                            if(page && page['pageType'] === 'overview'){
                                overViewPage[0]['reviewed'] = page['reviewed'];
                                page = overViewPage[0];
                            }
                            page['pageNumber'] = index+1;
                            newPages[index+1] = page;
                            return page;
                        });
                        roomDetails[roomId]['pages'] = cloneDeep(newPages);
                        }
                    }
            }
            projectData['roomDetails'] = roomDetails;
            let projectCreate = yield fetchDrawingApi(`projectDetails`,{
                method: "POST",
                body: JSON.stringify(projectData),
                headers:{
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                  }
            });
            projectCreate = yield projectCreate.json();
            if(projectCreate && projectCreate?.project){
                let {project} = projectCreate;
                projectData['roomDetails'][roomId] = project['roomDetails'][roomId];
            }
            let projectId = `${projectData.opportunityId}_${projectData.version}`; 
            yield put({type:ActionTypes.GET_PROJECT_SUCCESS, data:projectData})
            yield put((getPages({projectId , roomId })));
            yield put((setPageData({pageNumber:1, projectData }))) 

        }
    } catch (error) {
        console.error("Error in getPlanOverView", error);
        yield put({type:ActionTypes.GET_PROJECT_FAILURE, data:{error: `Sorry!! Rooms needs to have modules / furniture to generate a drawing or 2D Drawing images are not generated`}});
    }
    finally{
    yield put({type:ActionTypes.PAGE_LOADING_STATUS, status: 'ending'});
    }

}

// function maintainElevationId(newList, pagesArray){
//     try {
//         newList.map( function( item ) {
//             for( var i=0, len= pagesArray.length; i<len; i++ ){
//                 if( pagesArray[i]['name'] === item.name  && item.pageType === "elevation") {
//                     item['elevationId'] = pagesArray[i]['elevationId']
//                 }
//             }
//         });
//         return newList;
//     } catch (error) {
//         console.error("Error in maintainElevationId", error);
//     }
// }

/**Sort according to backend page order */

// function sortPageOrder(pages, sortOrder, key){
//     try {
//         pages.sort( function (a, b) {
//             var check = a[key], check1 = b[key];
//             if (sortOrder.indexOf(check) > sortOrder.indexOf(check1) || a['pageType'] === 'created_page') {
//               return 1;
//             } else {
//               return -1;
//             }
//         });
//         return pages;
//     } catch (error) {
//         console.error("Error in sortPageOrder", error);
//     }
// }

function* saveDrawing(action) {
    try{
        const canvas = yield select(fabricInstanceSelector);
        const pageDetails = yield select(pageDetailsSelector);
        const projectData = yield select(project);      
        const uploadingImage = yield select(uploadImageSelector);
        const fabricJSON = canvas.toJSON(['id', 'name', 'tableCode', 'tableTitle', 'tableHeading', 'tableOtherDetails', 'lockMovementX', 'lockMovementY', 'lockScalingX', 'lockScalingY', 'lockRotation', 'lockSkewingX', 'lockSkewingY', 'showTextBoxBorder'])
        pageDetails.drawing={drawingData:fabricJSON,
            screenSize:{
                screenWidth:window.screen.width,
                screenHeight:window.screen.height
            }
        };
        const {opportunityId, version, roomDetails} = projectData;
        const projectId = `${opportunityId}_${version}`, roomId=Object.keys(roomDetails)[0];
        const result = yield wizardClient.put(
        `pages/project/${projectId}/room/${roomId}`,
        {
            data: {[pageDetails.pageNumber]:pageDetails}, // add updated zone data here
        }
    );
    yield put({
        type: ActionTypes.SAVE_DRAWING_SUCCESS,
        result: result,
    });
    if(uploadingImage) {
        yield put({type:ActionTypes.UPLOADING_IMAGES, data: false});
    }

        // const result2 = yield wizardClient.get(
        //     `pages/project/0067879_1/room/1010`
        // );
        //
    } catch (e) {
    yield put({
        type: ActionTypes.SAVE_DRAWING_FAIL,
        result: action,
        error: '',
    });
    yield put({type:ActionTypes.UPLOADING_IMAGES, data: false});
}

}
function* exportPdf(action) {
    try{
        const {opportunityId, version, roomDetails} = action.projectData;
        const projectId = `${opportunityId}_${version}`, roomId=Object.keys(roomDetails)[0];
        const result = yield wizardClient.post(
        `pages/project/${projectId}/room/${roomId}`,
        {
            data: {},
        }
    );
    yield put({
        type: ActionTypes.EXPORT_FINAL_PDF_SUCCESS,
        result: result,
    });
    } catch (e) {
    yield put({
        type: ActionTypes.EXPORT_FINAL_PDF_FAIL,
        result: action,
        error: '',
    });
}

}


async function delayForImages(images){
     await Promise.all(
        images.map(img => {
          return new Promise((resolve, reject) => {
            let c = setInterval(()=>{
                if(img.complete){
                    clearInterval(c);
                    resolve("Done");
                }
            },200);
          });    
        })
      );
}

async function delayForPageInternalImage(){
    
    return new Promise((resolve, reject) => {
      let c = setInterval(()=> {
              clearInterval(c);
              resolve("Done");
      },2000);
    });    
  
}

function* savePageDetails(doc,className, page) {
    try{
        let isImagePresent = false;
        //TODO : Need to fix the code, Added hack to capture images.
        if(page?.drawing?.drawingData?.objects?.length){
            let imageObject=page?.drawing?.drawingData?.objects?.find(object=>object.type==="image");
            isImagePresent=imageObject?true:false;
        }
        yield call(delayForPageInternalImage);
        if(isImagePresent){
            let images=[];
            page?.drawing?.drawingData?.objects?.map(obj=>{
                if(obj.type==='image'){
                    let img = new Image();
                    img.src=obj.src;
                    images.push(img);
                }
            })
            yield call(delayForImages,images);
        }
        const width = doc.internal.pageSize.getWidth();
        const height = doc.internal.pageSize.getHeight();
         if(page && page['type'] === 'instruction'){
               doc.text('Instruction Page', 120,10, {maxWidth: 150, align: "justify"});
               let { links } = page;
               const links_arr=[]
              links.map((link, index)=>{
                if(link){
                    let cat_subcat = decodeURIComponent(link.split('/').pop() || 'Link');
                    let cat_subcat_trimmed = cat_subcat.split('.pdf');
                    links_arr.push(Object.create({'cat_subcat':cat_subcat_trimmed[0],'link':link}));
                }
                return link;
              });
              let cols = ["Categories/SubCategories", "Link to Instructions PDF"];
              var rows = [];
              links_arr.forEach(element => {
                var temp = [element.cat_subcat,element.link];
                rows.push(temp);
            });
           autoTable(
                 doc,{head:[cols],body:rows,theme:'plain',
                 tableLineWidth: 0.2,
                 tableLineColor:'black',
                 headStyles :{fillColor : [255,255,255],textColor:[0,0,0],cellPadding:5,lineColor:'black',lineWidth:0.2},
                 styles: {
                 fontSize: 10
                },
                columnStyles:{
                    0:{minCellWidth:170,lineWidth:0.2,lineColor:'black',valign:'middle'},
                    1:{textColor:'blue',lineColor:'black',lineWidth:0.2,valign:'middle'
                    }
                },
                willDrawCell: data => {
                    if (data.cell.section === 'body' && data.column.index === 1) {
                        doc.textWithLink("Click Here",data.cell.x*1.15,data.cell.y*1.07,{url: data.cell.text.join('')});     
                        data.cell.text = ['']; // just to avoid printing the url
                    }   
                },
                startY:20
            });
            const projectData = yield select(project);
            const qrRawValue = `${projectData?.opportunityId}:${page?.pageNumber}`;
            const qrDataUrl = yield QRCode.toDataURL(qrRawValue, { width: 90, margin: 1 });
            const pdfWidth = doc.internal.pageSize.getWidth();
            const pdfHeight = doc.internal.pageSize.getHeight();
            doc.addImage(qrDataUrl, 'PNG', pdfWidth - 22, pdfHeight - 22, 18, 18);
            doc.addPage();
        //     let defaultY= 25;
        //     if(links && links.length){
        //         //TODO: Need to add the styles changes
        //         doc.text('Instruction Page', 100,10, {maxWidth: 150, align: "justify"});
        //         (links || []).map((link, index)=>{
        //             doc.setFontSize(11);
        //             doc.setTextColor(23, 23, 239);
        //             index+=1;
        //             defaultY = index == 1 ? 25 : defaultY+15;
        //             doc.textWithLink(`${index}. ${decodeURIComponent(link.split('/').pop() || 'Link')}`, 25, defaultY , {url: link});
        //         });
        //         doc.addPage()
        //     }
         }else{
            var mainPageDiv = document.getElementById('mainPageDiv');
            mainPageDiv.scrollTop = 0;
            yield html2canvas(mainPageDiv,{useCORS: true,allowTaint:true,scale:3}).then(canvas => {
            const imgData = canvas.toDataURL('png',1);
            // const imgProps= doc.getImageProperties(imgData);
            // const pdfHeight = (imgProps.height * width) / imgProps.width;
            //Added width-1 as hack to add 1px margin
            doc.addImage(imgData, 'PNG', 0, 0, width-1, height, '','FAST');
            doc.addPage();
        })
        }
    }catch(error) {
        const previewMode = yield select(previewModeSelector);
        const exportMode =  yield select(exportDrawingStatusSelector);
        if(previewMode == 'enabled'){
            yield put({
                type:ActionTypes.PREVIEW_DRAWING_FAIL,
                error
            })
        }
        else if(exportMode==="inprogress"){
            yield put({
                type:ActionTypes.EXPORT_DRAWING_FAIL,
                error
            })
        }
        console.error("Error in savePageDetails", error);
    }
}
function* uploadDrawing(action) {
    try{
        const projectData = yield select(project);
        const {opportunityId,roomDetails} =projectData

        const projectId = `${opportunityId}`, roomId = Object.keys(roomDetails)[0];

        const displayPayload = new DisplayPayloadExtractor().buildPayload(
            Object.values(roomDetails[roomId]?.pages || {})
        );

        yield fetch(`${getSpacecraftUrl()}api/v1.0/project/${projectId}/2ddProjectDetails`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": yield select(accessToken)
             },
            body: JSON.stringify({
                roomID: roomId,
                someData: displayPayload,
            })
        });

        const uploadS3Url = yield wizardClient.post(
            `projects/${projectId}/rooms/${roomId}/drawing`,
            {
                data:action.data,
                serverName:'SC'
            })

        if(action?.categoriesWise) {
            categoriesS3Url[action?.categoriesWise] = uploadS3Url?.fileUrl || ''
        } else {
            window.open(action.doc.output('bloburl').toString());
        }


        showSnackbar('File uploaded successfully', 5000);

        yield put({
            type:ActionTypes.UPLOAD_DRAWING_SUCCESS
        })

    }
    catch(e) {
        yield put({
            type:ActionTypes.UPLOAD_DRAWING_FAIL
        })

    }

}
function* exportDrawing(action) {
    try{
        yield put({type:ActionTypes.ENABLE_LAYERING,data:false});
        let isDqc=yield select(isDqcDataPresent);
        if(!isDqc){
            return;
        }
        yield put({type:ActionTypes.EXPORT_DRAWING_INPROGRESS});
        yield put((resetZoom()));
        const zoom = window.screen.availWidth/window.innerWidth;
        if(zoom < 0.95) {
            yield put({
                type:ActionTypes.GET_PROJECT_FAILURE, 
                data:{error: `To export good resolution PDF, please reset your browser zoom setting to 100% or above.\nCurrent zoom level is ${Math.round(zoom*100)}%. Press CTRL(CMD) +/- to adjust zoom setting.`}
            }); 
            yield put({
                type:ActionTypes.EXPORT_DRAWING_FAIL
            })
            return;
        }

        const projectData = yield select(project);
        const pages = yield select(wizardSelector);
        const {opportunityId, roomDetails} = projectData
        const projectId = `${opportunityId}`;
        const roomId = Object.keys(roomDetails)[0];
        // @ts-ignore
        window.forceExport = true;
         // @ts-ignore
        if(!window.forceExport){
        const roomsWithTimeStamps = yield fetch(`${getSpacecraftDrawingUrl()}projects/${projectId}/RoomDrawingVersionTimeStamp`);
        const roomsWithTimeStampsJson = yield roomsWithTimeStamps.json();
        let currentRoomTimeStamp;
        roomsWithTimeStampsJson.map(room =>{
            if(roomId===room.roomId){
                currentRoomTimeStamp = room;
            }
            return room;
        })
        if(currentRoomTimeStamp &&currentRoomTimeStamp.roomUpdatedAt>currentRoomTimeStamp.drawingGenerationTimestamp){
            let roomChangedDate = new Date(currentRoomTimeStamp.roomUpdatedAt).toLocaleDateString([],{day:'numeric',month:'numeric',year:'numeric'});
            let last2ddGeneratedDate = new Date(currentRoomTimeStamp.drawingGenerationTimestamp).toLocaleDateString([],{day:'numeric',month:'numeric',year:'numeric'});
            let roomChangedTime = new Date(currentRoomTimeStamp.roomUpdatedAt).toLocaleString([], { hour: 'numeric', minute: 'numeric',second:'numeric' ,hour12: true  });
            let last2ddGeneratedTime = new Date(currentRoomTimeStamp.drawingGenerationTimestamp).toLocaleString([], { hour: 'numeric', minute: 'numeric',second:'numeric' ,hour12: true  });
            yield put({
                type:ActionTypes.GET_PROJECT_FAILURE, 
                data:{error: `Your room has been updated on ${roomChangedDate},${roomChangedTime} and 2DD was last generated on ${last2ddGeneratedDate},${last2ddGeneratedTime}. please regenerate 2dd from spacecraft`}
            }); 
            yield put({
                type:ActionTypes.EXPORT_DRAWING_FAIL
            })
            return;
        }
        }
        
        const { roomName } = roomDetails[roomId];
        const {Client_Id: clientName} = projectData.customer_details;

        let pagesNotReviewed = Object.values(pages).filter((p:any) => {
            return (!p.reviewed && !p.isOptional && !p?.name?.includes("OLD PAGE"));
        }).length;
        // @ts-ignore
        if(window.disableReview){
            pagesNotReviewed = null;
        }
        if(pagesNotReviewed) {
            yield put({
                type:ActionTypes.GET_PROJECT_FAILURE, 
                data:{error: `Please mark all pages as reviewed before publishing!`}
            }); 
            yield put({
                type:ActionTypes.EXPORT_DRAWING_FAIL
            })
            return;
        }

        const listOfApprovalImages = [];
        const unwantedPages = Object.values(pages).filter((p:any) => {
            return (p.isOptional && !p?.name?.includes("OLD PAGE"));
        });
        let unwantedPagesList=``;
        if(unwantedPages.length>0){
                unwantedPages.map((page:any) => {
                    unwantedPagesList = unwantedPagesList.concat(`${page.name}(Pg.No: ${page.pageNumber}), \n`);
                })
                showSnackbar(`Below Mentioned Pages Marked Unwanted, These Pages Will Not Be Shown In The Exported Drawing
                ${unwantedPagesList}`);
        }

        const exportablePages = Object.values(pages).filter((p:any) => !p?.isOptional && !p?.name?.includes("OLD PAGE"));
        if(exportablePages.length === 0) {
            showSnackbar(`All pages are marked as unwanted. Please mark at least one page as required before exporting.`);
            yield put({ type: ActionTypes.EXPORT_DRAWING_FAIL });
            return;
        }


        const doc =new jsPDF('l','mm', 'a4', true);
        const Pages = yield select(wizardSelector);
        const verifiedPageList = {};
        const reviewedPages = []
        for (const key in Pages) {
            if(disconnected){
                yield put({
                    type:ActionTypes.GET_PROJECT_FAILURE, 
                    data:{error: `Your internet connection is unstable,please refresh & export 2DD after some time`}
                });
                yield put({
                    type:ActionTypes.EXPORT_DRAWING_FAIL
                })
                throw new Error("Internet unstable");
            }
            let exportDrawingStatus = yield select(exportDrawingStatusSelector);
            if(exportDrawingStatus !== "inprogress"){
                yield put({
                    type:ActionTypes.GET_PROJECT_FAILURE, 
                    data:{error: `Sorry!! wrror while fetching page details.kindly try exporting again`}
                }); 
                yield put({
                    type:ActionTypes.EXPORT_DRAWING_FAIL
                })
                return;
            }
            if(navigator.onLine){
            let pageObj = Pages[key]
            // @ts-ignore
            if(pageObj && (!pageObj.reviewed && !window.disableReview) && !pageObj?.isOptional && !pageObj?.name?.includes("OLD PAGE")){
                yield put({
                    type:ActionTypes.GET_PROJECT_FAILURE, 
                    data:{error: `Please mark all pages as reviewed before publishing!`}
                }); 
                yield put({
                    type:ActionTypes.EXPORT_DRAWING_FAIL
                })
                return;
            }
            if(pageObj && (pageObj?.isOptional || pageObj?.name?.includes("OLD PAGE")) )
                continue;
            yield call(getPageDetails,{data:pageObj});
            yield call(savePageDetails,doc,'pageContainer', pageObj);
            reviewedPages.push(pageObj);
            
            // HDS Multidoc creation
            for (const key in HDSPageSeparation) {
                if (HDSPageSeparation[key].some(val => val.toLowerCase() === pageObj.type.toLowerCase())) {
                    if (!verifiedPageList[key]) {
                        verifiedPageList[key] = new jsPDF('l','mm', 'a4', true);
                    }
                    yield call(savePageDetails,verifiedPageList[key],'pageContainer', pageObj);
                }
            }
        }
        else{
            break;
        }
        }

        if(reviewedPages?.length) {
            reviewedPages?.map((e, i) => {
                if(e?.approvalImageUrl) {
                    listOfApprovalImages.push({ pageNumber: Number(i) + 1, imageURL: e.approvalImageUrl, freshServiceTicket: e.freshServiceTicket })
                }
            })
        }

        if(!navigator.onLine){
            yield put({
                type:ActionTypes.GET_PROJECT_FAILURE, 
                data:{error: `Your internet connection is unstable,please re-export 2DD after some time`}
            });
            yield put({
                type:ActionTypes.EXPORT_DRAWING_FAIL
            })
            throw new Error("Internet unstable");
        }
        const pageCount = doc.getNumberOfPages();
        doc.deletePage(pageCount);
        
        doc.setProperties({
            title:`${clientName}-${roomName}-2DD`,
            keywords: `List of unwanted pages: ${unwantedPagesList}. ListOfApprovalImages: ${JSON.stringify(listOfApprovalImages)}`
        });
        const pdf = new File([doc.output("blob")], "2DD.pdf", {  type: "application/pdf" }),
            data = new FormData();
        data.append("pdf", pdf);

        yield call(pagewiseDocument, verifiedPageList, roomName);
        yield put((uploadExportDrawing(data, doc, '')))        
        yield put({
            type:ActionTypes.EXPORT_DRAWING_SUCCESS,
        })

    }
    catch(error) {
        yield put({
            type:ActionTypes.EXPORT_DRAWING_FAIL
        })

    }
}

function* getPagesList({data}){
    const { projectId, roomId } = data;
    const pagesCall = yield fetchDrawingApi(`pages/project/${projectId}/room/${roomId}`);
    const response = yield pagesCall.json();
    if(response && !response.error){
        //yield put((setPageData(response.pages[0])));
        yield put({
            type: ActionTypes.GET_PAGES_SUCCESS,
            data: response.pages
        })
    } 
}

/**
 * Function to fetch Images for SC
 */

function* getTagImages(data){
    try {
        const projectData = yield select(project);
        const {opportunityId,roomDetails} =projectData;
        const roomId = Object.keys(roomDetails)[0]
        let { tag, page } = data?.tag;
        page = (!page || Object.keys(page).length <=0) ? Object.assign({}, yield select(pageDetails)) : page;
        const fetchImages = yield fetch(`${getSpacecraftDrawingUrl()}projects/${opportunityId}/rooms/${roomId}/tag/${tag}`,{
            method: "GET",
            headers:{
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "Authorization": yield select(accessToken)
              }
        });

        if(fetchImages && fetchImages.status === 500){
            yield put({type:ActionTypes.GET_PROJECT_FAILURE, data:{error: `Sorry!! Error while getting images`}});
            return;
        }
        let imageUrls = yield fetchImages.json();
        if(!imageUrls){
            yield put({type:ActionTypes.GET_PROJECT_FAILURE, data:{error: `Sorry!! Unable to upload images`}});
            return;
        }
        
        
     //   page['images'] =  [];
        yield put((setPageDetails(page)));
        yield put((setDrawingData(page)));
    } catch (error) {
        console.error("Error in getTagImages", error);
    }
}

function splitArrayChunks(array, parts) {
    let result = [];
    for (let i = parts; i > 0; i--) {
        result.push(array.splice(0, Math.ceil(array.length / i)));
    }
    return result;
}

function splitArrayChunksBatch(array, parts, firstSet, maxSet) {
    let result = [];
    for(let i = 0; i < parts ; i++){
        if(parts>1 && i===0){
           result.push(array?.splice(0, firstSet))
        }else{
           result.push(array?.splice(0, maxSet))
        }
    }
    return result;
}

function* getPageDetails({data}){
    try {
        let {pageNumber,pageType, projectData} = data;
        if(!projectData)
            projectData = yield select(project);
        let orderProfile = yield select(orderProfileSelector);
        if(!['DOOWUP', 'HOMELANE']?.includes(orderProfile)) {
            orderProfile = 'HOMELANE'
        }
        let projectId = projectData.opportunityId, version = projectData.version, roomId = Object.keys(projectData.roomDetails)[0];
        if(!projectId || !roomId)
            return;
        let pageData = projectData.roomDetails[roomId]['pages'][pageNumber];
        if(!pageData)
            return;
            
        yield put(textSelected(false));
        yield put({type:ActionTypes.ENABLE_LAYERING,data:false});
        let roomType = projectData.roomDetails[roomId]['roomType'] || "default";
        const pageDetails = yield fetchDrawingApiWithRetry(`pages/project/${projectId}_${version}/room/${roomId}/page/${pageNumber}`,  { method: 'GET' });
        const previewMode = yield select(previewModeSelector);
            const exportMode =  yield select(exportDrawingStatusSelector);
            if((pageDetails && (!pageDetails.ok || pageDetails.status !==200)) || !pageDetails){
                if(previewMode==="enabled"){
                    yield put({
                        type:ActionTypes.PREVIEW_DRAWING_FAIL,
                        error:"Preview failed due to pagedetails api failure....Retry"
                    })   
                    yield put({type:ActionTypes.GET_PROJECT_FAILURE, data:{error: `Sorry!! Error while getting page details! please preview after some time`}});
                }
                if(exportMode==="inprogress"){
                    yield put({
                        type:ActionTypes.EXPORT_DRAWING_FAIL,
                        error:"Export failed due to pagedetails api failure....Retry"
                    })
                    yield put({type:ActionTypes.GET_PROJECT_FAILURE, data:{error: `Sorry!! Error while getting page details! please re-export`}});
                }
                return;
        }
        const response  = yield pageDetails.json();
        let {type, elevationId, isConstructionPage} = pageData;
        // elevationId = '3279359a-b71a-40a2-8859-5a616898b55a';
        let viewType = type.toLowerCase();
        if(response && !response.error){
            let {page} = response;
            if((pageType && pageType === "created_page" && !isConstructionPage)){
                yield put((setPageDetails(page)));
                yield put((setDrawingData(page)));
                return;
            }else{
                pageData['drawing'] = page?.drawing;
                pageData['notes'] = page?.notes;
                pageData['metaData'] = page?.metaData;
            }
        }
        if(['overview', 'internal', 'instruction', 'appliances'].includes(viewType) || (roomType === "default" && viewType === 'plan')){
                console.log(pageData.name);
                if(pageData.name.includes("Modular Beds")){
                    pageData.essentialNotes = roomNotes[orderProfile]["Modular_Beds"];
                }
                if(pageData.name.includes("Entertainment")){
                    pageData.essentialNotes = roomNotes[orderProfile]["EntertainmentUnit"];
                }
                if(pageData.name.includes("HL-Juniors")){
                    pageData.essentialNotes = roomNotes[orderProfile]["HL_Juniors"];
                }
                if(pageData.name.includes("Foyer") || pageData.name.includes("Puja") || pageData.name.includes("Study")){
                    pageData.essentialNotes = roomNotes[orderProfile]["Foyer_Puja_Study"];
                }
                if(pageData.name.includes("FloorStanding")){
                    pageData.essentialNotes = roomNotes[orderProfile]["FloorStanding"];
                }
                if(pageData.name.includes("Hinged") || pageData.name.includes("Versa") || pageData.name.includes("Floor") || pageData.name.includes("Slid")){
                    pageData.essentialNotes = roomNotes[orderProfile]["Wardrobe"];
                }
            yield put((setPageDetails(pageData)));
            yield put((setDrawingData(pageData)));
            
        }else{
            let url = `${getSpacecraftDrawingUrl()}projects/${projectId}/rooms/${roomId}/planview`;
            if(viewType === 'dimension'){
                url = `${getSpacecraftDrawingUrl()}projects/${projectId}/rooms/${roomId}/elevation/${elevationId}/dimension`;
            }else if(viewType === 'material'){
                url = `${getSpacecraftDrawingUrl()}projects/${projectId}/rooms/${roomId}/elevation/${elevationId}/material`;
            }else if(viewType === 'internal'){
                url = `${getSpacecraftDrawingUrl()}projects/${projectId}/rooms/${roomId}/elevation/${elevationId}/internal`;
            }else if(viewType === 'crosssection'){
                url = `${getSpacecraftDrawingUrl()}projects/${projectId}/rooms/${roomId}/elevation/${elevationId}/crossSection`;
            }
            else if(viewType === 'sitedetail'){
                url = `${getSpacecraftDrawingUrl()}projects/${projectId}/rooms/${roomId}/elevation/${elevationId}/sitedetail`;
            }else if(['electrical', 'wall_electrical'].includes(viewType)){
                url = `${getSpacecraftDrawingUrl()}projects/${projectId}/rooms/${roomId}/elevation/${elevationId}/electrical`;
            }else if(viewType === 'plumbing'){
                url = `${getSpacecraftDrawingUrl()}projects/${projectId}/rooms/${roomId}/elevation/${elevationId}/plumbing`;
            }else if(viewType === 'lightingplan'){
                url = `${getSpacecraftDrawingUrl()}projects/${projectId}/room/${roomId}/service/lighting/plan`
            }else if(['wall_decor'].includes(viewType)){
                url = `${getSpacecraftDrawingUrl()}projects/${projectId}/rooms/${roomId}/elevation/${elevationId}/walldecor`
            }else if(['flooring', 'wooden_flooring'].includes(viewType)){
                url = `${getSpacecraftDrawingUrl()}projects/${projectId}/rooms/${roomId}/floorTile`
            }else if(viewType === 'countertop'){
                url = `${getSpacecraftDrawingUrl()}projects/${projectId}/rooms/${roomId}/countertop`;
            }else if(viewType === 'modulelist'){
                url = `${getSpacecraftDrawingUrl()}projects/${projectId}/rooms/${roomId}/modules`;
            }
            else if(viewType === 'shutter_material'){
                url = `${getSpacecraftDrawingUrl()}projects/${projectId}/rooms/${roomId}/elevation/${elevationId}/shuttermaterial`;
            }
            else if(viewType === 'shutterextension'){
                url = `${getSpacecraftDrawingUrl()}projects/${projectId}/rooms/${roomId}/elevation/${elevationId}/shutterExtension`;
            }
            else if(viewType === 'countertop_elevation'){
                url = `${getSpacecraftDrawingUrl()}projects/${projectId}/rooms/${roomId}/elevation/${elevationId}/countertop`
            }
            else if(viewType === 'gas_outlet'){
                url = `${getSpacecraftDrawingUrl()}projects/${projectId}/rooms/${roomId}/elevation/${elevationId}/gasOutlet`;
            }
            else if(viewType === 'wall_tile'){
                url = `${getSpacecraftDrawingUrl()}projects/${projectId}/rooms/${roomId}/elevation/${elevationId}/wallTile`;
            }
            else if(viewType && 
                    (viewType.includes('bespoke') || viewType.includes('demolition') || viewType.includes('other_services') ||
                     viewType.includes('falseceiling') || viewType.includes('electricalservices') || 
                     viewType.includes('plumbingservices') || viewType.includes('showercubicles') || 
                     viewType.includes('drapes&upholstery') || viewType.includes('countertopmaterial&services') || 
                     viewType.includes('renovation') || viewType.includes('paintingservice') || 
                     viewType.includes('wallpaperservice') || viewType.includes('flooringservice') || 
                     viewType.includes('lightingservice') || viewType.includes('loosefurnitures'))){
                yield call(getTagImages,{tag:{tag: viewType, page:pageData}})
                return;
            }
            const pageDetails = yield fetchWithRetry(url,  { headers:{ "Authorization": yield select(accessToken) } });
            if((pageDetails && (!pageDetails.ok || pageDetails.status !==200)) || !pageDetails){
                if(previewMode==="enabled"){
                    yield put({
                        type:ActionTypes.PREVIEW_DRAWING_FAIL,
                        error:"Preview failed due to pagedetails api failure....Retry"
                    })   
                }
                if(exportMode==="inprogress"){
                    yield put({
                        type:ActionTypes.EXPORT_DRAWING_FAIL,
                        error:"Export failed due to pagedetails api failure....Retry"
                    })
                }
                yield put({type:ActionTypes.GET_PROJECT_FAILURE, data:{error: `Sorry!! Error while getting page details! please retry`}});
                return;
            }
            let response  = yield pageDetails.json();
            if(response){
                switch(viewType){
                    case 'plan':
                        //let {productSpecificationList, carcassDepth, measuredPlanImageUrl,carcassMaterialSpecificationList, softcloseSpecification, frameAndShutterSpecification, handles} = response;
                        //let emptyKeys = [];
                        pageData["sidebarInfo"]=sidebarInfo[orderProfile]['PLAN']['kitchen'];

/*
                        if(carcassMaterialSpecificationList?.length){
                            (carcassMaterialSpecificationList || []).map(obj=>{
                                let productName = obj['productName'];
                                let carcassData=obj.carcassData;
                                let parentData=carcassData.length>0?carcassData.reduce((acc,data)=>{
                                   return acc["moduleNumbers"]?.length>data['moduleNumbers']?.length?acc:data;
                                },carcassData[0]):{...carcassData[0]};
                                let listData=[];
                                let tableCount=0;
                                carcassData.map((data)=>{
                                    let name=data.carcassMaterial;
                                    if(parentData && data.carcassColorCode!=parentData?.carcassColorCode){
                                        let moduleNames=data.moduleNumbers.length>1?data.moduleNumbers?.join(","):data.moduleNumbers[0];
                                        name=`${data.carcassMaterial}(${moduleNames})`
                                    }
                                    if(listData.length<3){
                                        listData.push({
                                            carcassMaterial:name,
                                            carcassColorCode:data.carcassColorCode,
                                            carcassColor:data.carcassColor
                                        })
                                    }
                                    else{
                                        pageData['carcaseDetails'][`${productName}_${tableCount}`] = listData;
                                        listData=[];
                                        tableCount++;
                                    }
                                })
                                if(listData.length){
                                  pageData['carcaseDetails'][`${productName}_${tableCount}`] = listData;
                                }
                            })
                        }
                        (emptyKeys || []).map(emtyKey=>{
                            delete pageData['carcaseDetails'][emtyKey];
                        })

*/
                        // let carcaseDepth ={} 
                        // carcassDepth.map(carcase=>{
                        //     carcaseDepth[carcase['productName']] = {name:carcase['productName'], value: carcase.depth};
                        // });
                        // carcaseDepth['heading'] = "STANDARD CARCASS DEPTH";
                        // pageData['carcaseDetails']['carcaseDepth']=carcaseDepth;
/*
                        pageData['measuredPlanImageUrl'] = measuredPlanImageUrl;
                        // const softCloseKeys = Object.keys(softcloseSpecification) || [];
                        const frameKeys = Object.keys(frameAndShutterSpecification) || [];
                        // pageData = mapTemplateKeys(pageData, softCloseKeys, softcloseSpecification, 'softcloseSpecification');
                        pageData = mapTemplateKeys(pageData, frameKeys, frameAndShutterSpecification, 'frameAndShutterSpecification');
                        if(handles && handles.length > 0){
                            let handlesArry =[];
                            handles.map(handle=>{
                                if(handle['handleData'] && Object.keys(handle['handleData']).length > 0){
                                    let handleData = {
                                        item: handle['handleData']['isInternal'] ? handle['handleData']['name']+" (Int)" : handle['handleData']['name'],
                                        code: handle['handleData']['id'],
                                        size: handle['handleData']['size']+" mm",
                                        pitch: handle['handleData']['pitch']+" mm",
                                        partType:handle['partType'],
                                        image: handle['handleData']['image'],
                                        budgetType:handle['handleData']['budgetType']
                                    };
                                    if(roomType !== "kitchen"){
                                        handleData.partType = handle.subCategoryName;
                                    }
                                    handlesArry.push(handleData)
                                }
                            });
                            if(handlesArry && handlesArry.length > 0){
                                // handlesArry = handlesArry.filter((elem, index, self) => self.findIndex(
                                //     (t) => {return (t.item == elem.item && t.code == elem.code)}) === index)
                                handlesArry=handlesArry.sort((a, b) => a.partType.localeCompare(b.partType));
                                for(let i=0;i<handlesArry.length;i+=maxRowsHandleTable){
                                    let tempArray=handlesArry.slice(i,i+maxRowsHandleTable);
                                    pageData['carcaseDetails'][`HANDLES_${i}`] = tempArray;
                                }
                            }
                        }
*/
                    break;
                    case 'dimension':{
                        let {elevationName=""} = response;
                        
                        if(roomType==="kitchen"){
                            pageData['sidebarInfo']=sidebarInfo[orderProfile]['DIMENSION']['floor standing'];
                        }
                        else{
                                if(pageData.name.includes("Modular Beds")){
                                    pageData.essentialNotes = roomNotes[orderProfile]["Modular_Beds"];
                                }
                                if(pageData.name.includes("Entertainment")){
                                    pageData.essentialNotes = roomNotes[orderProfile]["EntertainmentUnit"];
                                }
                                if(pageData.name.includes("HL-Juniors")){
                                    pageData.essentialNotes = roomNotes[orderProfile]["HL_Juniors"];
                                }
                                if(pageData.name.includes("Foyer") || pageData.name.includes("Puja") || pageData.name.includes("Study")){
                                    pageData.essentialNotes = roomNotes[orderProfile]["Foyer_Puja_Study"];
                                }
                                if(pageData.name.includes("FloorStanding")){
                                    pageData.essentialNotes = roomNotes[orderProfile]["FloorStanding"];
                                }
                                if(pageData.name.includes("Hinged") || pageData.name.includes("Versa") || pageData.name.includes("Floor") || pageData.name.includes("Sliding")){
                                    pageData.essentialNotes = roomNotes[orderProfile]["Wardrobe"];
                                }
                            Object.keys(sidebarInfo[orderProfile]["DIMENSION"]).some(subcategory=>{
                                if(elevationName.toLowerCase().includes(subcategory)){
                                    pageData['sidebarInfo']=sidebarInfo[orderProfile]["DIMENSION"][subcategory];
                                    return true;
                                }
                                else{
                                    return false;
                                }
                            })
                        }
                        // pageData['skirting']= []
                        // if(skirtings && skirtings.length > 0){
                        //     // let skirtingHeight = skirtings?.[0]?.['skirtingHeight'] || skirtings?.[0]?.['leg']?.['height'];
                        //     // pageData['skirting']['details']['SKIRTING HEIGHT'] = skirtingHeight?(skirtingHeight+"MM"):"NA";
                        //     // pageData['skirting']['details']['SKIRTING COLOR'] = skirtings[0]['leg'] ? skirtings[0]['color']['colourName']: "NA";
                        //     // pageData['skirting']['details']['SKIRTING HEIGHT']='';
                        //     // pageData['skirting']['details']['SKIRTING COLOR'] = '';
                        //     let skirting_pvc = {'details':{'SKIRTING HEIGHT':'','SKIRTING COLOR':''},'heading':'PVC SKIRTING DETAILS'};
                        //     let skirting_wooden = [];
                        //     skirtings?.map(skirting => {
                        //         if(skirting.skirtingId){
                        //         let skirtingHeight = skirting?.['skirtingHeight'] || skirting?.['leg']?.['height'];
                        //         // if(!pageData['skirting']['details']['SKIRTING HEIGHT']?.includes(skirtingHeight)){
                        //         // pageData['skirting']['details']['SKIRTING HEIGHT'] += skirtingHeight?(skirtingHeight+"MM,"):"NA,";
                        //         // }
                        //         // if(!pageData['skirting']['details']['SKIRTING COLOR']?.includes(skirting['color']['colourName'])){
                        //         // pageData['skirting']['details']['SKIRTING COLOR'] += skirting['leg'] ? skirting['color']['colourName']+",": "NA,";
                        //         // }
                        //         if(!skirting_pvc['details']['SKIRTING HEIGHT']?.includes(skirtingHeight)){
                        //             skirting_pvc['details']['SKIRTING HEIGHT'] += skirtingHeight?(skirtingHeight+"MM,"):"NA,";
                        //         }
                        //         if(!skirting_pvc['details']['SKIRTING COLOR']?.includes(skirting['color']['colourName'])){
                        //             skirting_pvc['details']['SKIRTING COLOR'] +=  skirting['leg'] ? skirting['color']['colourName']+",": "NA,";
                        //         }
                        //         }
                        //         else{
                        //             let wSkirtingHeight = skirting?.['skirtingHeight'] || skirting?.['leg']?.['height'];
                        //             let wSkirtingColor = skirting['color']['colourName'];
                        //             skirting_wooden?.push({'details':{'SKIRTING HEIGHT':wSkirtingHeight,'SKIRTING COLOR':wSkirtingColor},'heading':'WOODEN SKIRTING DETAILS'})
                                    
                        //         }
                        //     })
                        //     pageData['skirting'].push(skirting_pvc);
                        //     pageData['skirting'].push(...skirting_wooden);
                        // }else{
                        //     // pageData['skirting']['details']['SKIRTING HEIGHT'] = "NA";
                        //     // pageData['skirting']['details']['SKIRTING COLOR'] = "NA";
                        //     pageData['skirting'].push({'details':{'SKIRTING HEIGHT':'NA','SKIRTING COLOR':'NA'},'heading':'PVC SKIRTING DETAILS'})
                        // }
                        // if(softCloseSpecifications && softCloseSpecifications.length){
                        //     pageData['softCloseSpecifications'] = softCloseSpecifications
                        // }
                        // if(carcassDepthList && carcassDepthList.length){
                        //     pageData['carcassDepthList'] = carcassDepthList
                        // }
                        
                        //     pageData['loftSlabPresent'] = loftSlabPresent;
                        
                        // pageData['elevationImage'] = elevationImage;
                        break;
                    }
                 //   case 'shutter_material':
                    case 'material':{
                        let {elevationImage, elevationName=""} = response;
                        if(roomType==="kitchen"){
                            pageData['sidebarInfo']=sidebarInfo[orderProfile]["MATERIAL"]['floor standing'];
                        }
                        else{
                                if(pageData.name.includes("Modular Beds")){
                                    pageData.essentialNotes = roomNotes[orderProfile]["Modular_Beds"];
                                }
                                if(pageData.name.includes("Entertainment")){
                                    pageData.essentialNotes = roomNotes[orderProfile]["EntertainmentUnit"];
                                }
                                if(pageData.name.includes("HL-Juniors")){
                                    pageData.essentialNotes = roomNotes[orderProfile]["HL_Juniors"];
                                }
                                if(pageData.name.includes("Foyer") || pageData.name.includes("Puja") || pageData.name.includes("Study")){
                                    pageData.essentialNotes = roomNotes[orderProfile]["Foyer_Puja_Study"];
                                }
                                if(pageData.name.includes("FloorStanding")){
                                    pageData.essentialNotes = roomNotes[orderProfile]["FloorStanding"];
                                }
                                if(pageData.name.includes("Hinged") || pageData.name.includes("Versa") || pageData.name.includes("Floor") || pageData.name.includes("Sliding")){
                                    pageData.essentialNotes = roomNotes[orderProfile]["Wardrobe"];
                                }
                            Object.keys(sidebarInfo[orderProfile]["MATERIAL"]).some(subcategory=>{
                                if(elevationName.toLowerCase().includes(subcategory)){
                                    pageData['sidebarInfo']=sidebarInfo[orderProfile]["MATERIAL"][subcategory];
                                    return true;
                                }
                                else{
                                    return false;
                                }
                            })
                        }
                        pageData['elevationImage'] = elevationImage;
                        break;
                    }
                    case 'shutterextension':{
                        let { elevationImage} = response;
                        pageData['elevationImage'] = elevationImage;
                        break;
                    }
                    case 'internal':{
                        let {accessorySpecificationList, elevationImage,elevationName="",isBackPanelAdded} = response;
                        if(roomType==="kitchen"){
                            pageData['sidebarInfo']=sidebarInfo[orderProfile]["INTERNAL"]['floor standing'];
                        }
                        else{
                                if(pageData.name.includes("Modular Beds")){
                                    pageData.essentialNotes = roomNotes[orderProfile]["Modular_Beds"];
                                }
                                if(pageData.name.includes("Entertainment")){
                                    pageData.essentialNotes = roomNotes[orderProfile]["EntertainmentUnit"];
                                }
                                if(pageData.name.includes("HL-Juniors")){
                                    pageData.essentialNotes = roomNotes[orderProfile]["HL_Juniors"];
                                }
                                if(pageData.name.includes("Foyer") || pageData.name.includes("Puja") || pageData.name.includes("Study")){
                                    pageData.essentialNotes = roomNotes[orderProfile]["Foyer_Puja_Study"];
                                }
                                if(pageData.name.includes("FloorStanding")){
                                    pageData.essentialNotes = roomNotes[orderProfile]["FloorStanding"];
                                }
                                if(pageData.name.includes("Hinged") || pageData.name.includes("Versa") || pageData.name.includes("Floor") || pageData.name.includes("Slid")){
                                    pageData.essentialNotes = roomNotes[orderProfile]["Wardrobe"];
                                }
                            Object.keys(sidebarInfo[orderProfile]["INTERNAL"]).some(subcategory=>{
                                if(elevationName.toLowerCase().includes(subcategory)){
                                    pageData['sidebarInfo']=sidebarInfo[orderProfile]["INTERNAL"][subcategory];
                                    return true;
                                }
                                else{
                                    return false;
                                }
                            })
                        }
                        if(response.hasOwnProperty('isBackPanelAdded')){
                          let additionalNotes=isBackPanelAdded?"| Back panel is added |":"| Back panel is not added |";
                          addPageNotes(additionalNotes,pageData,"Back panel");
                        }
                        pageData['accessorySpecificationList'] = accessorySpecificationList;
                        pageData['elevationImage'] = elevationImage;
                        break;
                    }

                    case 'crosssection':{
                        let {elevationImage,visualizerMetaData} = response;
                        pageData['visualizerMetaData'] = visualizerMetaData;
                        pageData['elevationImage'] = elevationImage;
                        break;
                    }
                    // case 'lighting' :{
                    //     let {imageData,data} = response;
                    //     pageData['lightingPointsDetails'] = data;
                    //     pageData['elevationImage'] = imageData;
                    //     break;
                    // }
                    case 'sitedetail':{
                        let { elevationImage,siteDetail} = response;
                        pageData['elevationImage'] = elevationImage;
                        pageData['siteDetail'] = {};
                        let siteDetailArr = [];
                        Object.entries(siteDetail).map(property => {
                            siteDetailArr.push({key:property[0].replace('-',' '),value:property[1]});
                            return property;
                        })
                        for(var i=0;i<siteDetailArr.length;i+=5){
                            let tempArr = siteDetailArr.slice(i,i+5);
                            pageData['siteDetail'][`siteDetails_${i}`] = tempArr;
                        }
                        break;
                    }
                    case 'electrical':
                    case 'wall_electrical': {
                        let {elevationImage, electricalMetaData } = response;
                        let { electricalInfoList, scope ,serviceAnnotationMapping } = electricalMetaData;
                        pageData['elevationImage'] = elevationImage?.imageUrl;
                        //pageData['name'] = elevationName;
                        pageData['serviceAnnotationMapping'] = serviceAnnotationMapping;
                        if(electricalInfoList && electricalInfoList.length){
                            pageData['electricalData'] = electricalInfoList;
                        }
                        if(scope){
                            pageData['electricalNotifications']['scope'] = scope;
                        }
                        break;
                    }
                    case 'plumbing':{
                        let {elevationImage, plumbingMetaData } = response;
                        let { plumbingInfoList } = plumbingMetaData;
                        pageData['elevationImage'] = elevationImage?.imageUrl;
                        //pageData['name'] = elevationName;
                        if(plumbingInfoList && plumbingInfoList.length){
                            pageData['plumbingData'] = plumbingInfoList;
                        }
                        break;
                    }
                    //case 'lightingoverview':{
                        // let { lightingItems } = response;
                        // let countedObj = {};
                        // if(lightingItems && lightingItems.length > 0){
                        //     countedObj=lightingItems.reduce((acc,item)=>{
                        //         if(acc[item.productSku]){
                        //             acc[item.productSku]["totalCount"]+=item["count"];
                        //         }
                        //         else{
                        //             item["totalCount"]=item["count"];
                        //             acc[item.productSku]=item;
                        //         }
                        //         return acc;
                        //     },{})
                        // }
                        // pageData['overviewDetails'] = Object.keys(countedObj).length?Object.values(countedObj): []
                    //     break;
                    // }
                    // case 'lightingplan': {
                    //     let { imageData, data } = response;
                    //     let {appPage} = pageData;
                    //     if(imageData){
                    //         let { imageUrl } = imageData;
                    //         pageData['planImage'] = imageUrl;
                    //     }
                    //     data = data.sort((a,b) => {return a?.point.localeCompare(b?.point)});
                    //     if(data && data.length){
                    //         let numberForSplits = Math.ceil(data.length/maxRowsLightPlanList);
                    //         let splitArray = splitArrayChunks(data, numberForSplits);
                    //         pageData['lightingPlanDetails'] = splitArray[appPage-1];
                    //     }
                    //     break;
                    // }
                    case 'wall_decor':{
                        let { elevationId,elevationImage, wallDecorMetaData } = response;
                        let { wallpaperDetails, paintDetails} = wallDecorMetaData;
                        pageData['elevationImage'] = elevationImage;
                        pageData['elevationId'] = elevationId;
                        if((wallpaperDetails && wallpaperDetails.length>0) || (paintDetails && paintDetails.length > 0)){
                            pageData['paintDetails'] = paintDetails;
                            pageData['wallpaperDetails'] = wallpaperDetails;
                        }
                        if(paintDetails && paintDetails.length){
                            let isOilPrimer = paintDetails.find(data=> data.woodworkCovering);
                            if(isOilPrimer) {
                                let additionalNotes="| Oil Primer enables the adhesive to stick better between the media and wall |";
                                addPageNotes(additionalNotes,pageData,"Oil Primer enables");
                            }
                        }
                        break;
                    }
                    case 'flooring':
                    case 'wooden_flooring':
                        {
                        let { imageData, floorTilesMetaData } = response;
                        pageData['elevationImage'] = imageData || {};
                        if(floorTilesMetaData && Object.keys(floorTilesMetaData).length>0){
                            pageData['floorTilesMetaData'] = floorTilesMetaData;
                        }
                        break;
                    }
                    case 'countertop':
                    case 'countertop_elevation':{
                        let { imageData, nameHeight} = response;
                        let {appPage}=pageData;
                        if(viewType==='countertop_elevation'){
                            imageData=response['elevationImage'];
                            nameHeight=response['nameAndHeight'];
                            nameHeight=nameHeight.sort((a,b)=>a?.Annotation?.localeCompare(b?.Annotation));
                        }
                        if(appPage && nameHeight.length){
                            let numberForSplits = Math.ceil(nameHeight.length/maxCounterTopTables);
                            let splitArray = splitArrayChunks(nameHeight, numberForSplits);
                            nameHeight = splitArray[appPage - 1];
                        }
                        pageData['elevationImage'] = imageData || {};
                        let tables={};
                        if(nameHeight && nameHeight.length){
                            let data = nameHeight.map((counterTop)=>{
                                return ({
                                    "Annotation":counterTop.Annotation,
                                    "NAME":counterTop.Name,
                                    "TYPE":counterTop.Type,
                                    "COLOUR":counterTop.Colour,
                                    "THICKNESS":counterTop.Thickness,
                                    "NOISINGTYPE":counterTop.Nosing,
                                    "PLY FOR DOUBLE NOSING":counterTop["Base ply included"],
                                    "NOSING THICKNESS":counterTop.Thickness,
                                    "BACKSPLASH HEIGHT":counterTop["Backsplash Height"]?`${counterTop["Backsplash Height"]} MM`:"",
                                    "OVERHANG (L, R, B, F)":`${counterTop["Overhang Left"]?.toUpperCase() || "0 MM"}, ${counterTop["Overhang Right"]?.toUpperCase() || "0 MM"}, ${counterTop["Overhang Back"]?.toUpperCase() || "0 MM"}, ${counterTop["Overhang Front"]?.toUpperCase() || "0 MM"}`,
                                   
                                })
                            })
                            
                            tables['COUNTERTOP']=data;
                            pageData["tables"]=tables;
                        }
                        break;
                    }
                    case "modulelist":{
                        // let {zones} = response;
                        let { appPage } = pageData;
                        // let modulesList = []; 
                    //    zones?.map(zone => {
                    //        modulesList.push(...zone['modules']);
                    //    })
                      
                        //    let numberForSplits =Math.ceil(modulesList.length/maxRowsModuleList);
                        //    let splitArray = splitArrayChunks(modulesList, numberForSplits);
                       
                        //    if(!splitArray[appPage-1]){
                        //        pageData['moduleList'] = {}
                        //        break;
                        //    }
                            
                           let page_modules;
                           
                           if(splitted_modules[appPage-1]){
                                page_modules = splitted_modules[appPage-1];
                           }
                           else{
                               page_modules=[]
                           }

                           page_modules = page_modules?.map(module=>{
                                        if(module?.subcategoryName === 'Floor-to-Ceiling'  && module?.moduleName?.includes('Armadio Shutter')){
                                            module["name"] = `${module?.moduleName} | SOFT CLOSE`;
                                        }else{
                                            module["name"]=`${module?.moduleName} | ${module?.softClose?`SOFT CLOSE | ${module?.softCloseType} | ${module?.softCloseMake!=="NA"? module?.softCloseMake: ""}`:"NON-SOFT CLOSE"}`;
                                        }

                                        if(module?.onConcreteLedge) {
                                            module["name"] += ' | On Concrete Ledge';
                                        }
                                        module["accessoryDetails"]=module?.accessoryPayload?.length?
                                           module?.accessoryPayload?.map(accessory=> {
                                                if(module?.subcategoryName !== 'Floor-to-Ceiling' ){
                                                    return accessory?.name?`${accessory?.name} | ${accessory?.softClose?"SOFT CLOSE":"NON-SOFT CLOSE"}`:""
                                                }
                                                else{
                                                    return accessory?.name? accessory?.name : ''
                                                }
                                            }
                                            )
                                        :"NA";
                                        module["handleDetails"]=module?.handle?.length?
                                        [...new Set(module?.handle?.map(h => (h?.name ? (h?.isInternal ? `${h.name} (Int)` : h.name) : "")))]
                                        :"NA";
                                       return module;
                           })
                           let modules_tables={};
                           page_modules.forEach(module => {
                               let key = module.zoneObjectId;
                               if(!modules_tables[key]) {
                                   modules_tables[key] = [];
                               }
                               modules_tables[key].push(module);
                           });
                           pageData['moduleList'] = modules_tables;
                          break;
                                           // modulesList=modulesList.sort((a, b) => a.moduleAnnotation.localeCompare(b.moduleAnnotation)).sort((a, b) => a.zoneName.localeCompare(b.zoneName));
                        }
                    case "gas_outlet":{
                        let { elevationImage, gasOutletMetaData } = response;
                        pageData["elevationImage"]=elevationImage?.imageUrl;
                        pageData["gasOutletData"]=gasOutletMetaData?.gasOutletInfoList || [];
                        break;
                    }
                    case 'wall_tile':{
                        let {elevationImage, wallTileDetails = {}, elevationName, coverageArea, thumbImage } = response;
                        pageData['elevationImage'] = elevationImage?.imageUrl;
                        pageData['name'] = elevationName;
                        pageData['thumbImage'] = thumbImage;
                        pageData['coverageArea'] = coverageArea;
                        if(wallTileDetails){
                            pageData['wallTileData'] = wallTileDetails;
                        }
                        
                        break;
                    }
                }
                if(response.customNote) {
                    addPageNotes(`| ${response.customNote} |`, pageData, response.customNote);
                } 
                yield put((setPageDetails(pageData)))
                yield put((setDrawingData(pageData)));
               
            }
        }
            
         
    } catch (error) {
        console.error("Error in pageDetails", error);
        const previewMode = yield select(previewModeSelector);
        const exportMode =  yield select(exportDrawingStatusSelector);
        if(previewMode == 'enabled'){
            yield put({
                type:ActionTypes.PREVIEW_DRAWING_FAIL,
                error
            })
        }
        else if(exportMode==="inprogress"){
            yield put({
                type:ActionTypes.EXPORT_DRAWING_FAIL,
                error
            })
        }
        yield put({type:ActionTypes.GET_PROJECT_FAILURE, data:{error: `Sorry!! Error while getting page details!`}});        
    } 
}

function* savePageOnReview({data}){
    try {
        let {page} = data;
        
        const projectData = yield select(project);
        const {opportunityId, version,roomDetails} =projectData
        const projectId = `${opportunityId}_${version}`;
        const roomId = Object.keys(roomDetails)[0];
        let {pageNumber} = page;
        projectData['roomDetails'][roomId]['pages'][pageNumber] = Object.assign(page);
        yield put({type:ActionTypes.GET_PROJECT_SUCCESS, data:projectData});
        let payload = {};
        payload[pageNumber]=page;
        const updatePage = yield fetchDrawingApi(`pages/project/${projectId}/room/${roomId}`,{
            method: "PUT",
            body: JSON.stringify(payload),
            headers:{
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        const reviewData = yield updatePage.json();
        if(reviewData && !reviewData.error){
            yield put((getPages({projectId, roomId})))  
            yield put((setPageDetails(page)));
            yield put((setDrawingData(page)));
        }   
    } catch (error) {
        
    }
}    

function* handleNewPageCreate({data}){
    try {
        let {newPage, pageNumber} = data;
        let projectData = yield select(project);
        let {opportunityId, version, roomDetails} = projectData;
        let projectId = `${opportunityId}_${version}`, roomId = Object.keys(roomDetails)[0];
        let pages = projectData['roomDetails'][roomId]['pages'];
        pages[pageNumber]= newPage;
        let payload = {};
        payload[pageNumber] = newPage;
        projectData['roomDetails'][roomId]['pages'] = Object.assign({}, pages);
        yield put({type:ActionTypes.GET_PROJECT_SUCCESS, data:projectData});
        const updatePage = yield fetchDrawingApi(`pages/project/${projectId}/room/${roomId}`,{
            method: "PUT",
            body: JSON.stringify(payload),
            headers:{
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        const newPageData = yield updatePage.json();
        if(newPageData && !newPageData.error){
            yield put((getPages({projectId, roomId})))
        }
        yield put(setPageData(payload[pageNumber]));
    } catch (error) {
        console.error("Error while creating a page", error);
    } 
}

function* handlePageIndexChange({data}){
    try {
        let {from, to} = data;
        let projectData = yield select(project);
        let {opportunityId, version, roomDetails} = projectData;
        let projectId = `${opportunityId}_${version}`, roomId = Object.keys(roomDetails)[0];
        if(!projectId || !roomId || !from || !to)
            return
        let pages = projectData['roomDetails'][roomId]['pages'];
        let toObj = pages[from];
        toObj['arranged'] = true;
        delete pages[from];
        let pageValues = Object.values(pages), newPages={};
        pageValues.splice(to ===1 ? 0: parseInt(to)-1, 0, toObj);
        pageValues.map((page, index)=>{
            page['pageNumber'] = index+1;
            newPages[index+1] = page;
            return page;
        });
        projectData['roomDetails'][roomId]['pages'] = Object.assign({}, newPages);
        yield put({type:ActionTypes.GET_PROJECT_SUCCESS, data:projectData})    
        const updatePage = yield fetchDrawingApi(`pages/project/${projectId}/room/${roomId}`,{
            method: "PUT",
            body: JSON.stringify(newPages),
            headers:{
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        const newPageData = yield updatePage.json();
        if(newPageData && !newPageData.error){
            yield put((getPages({projectId, roomId})))  
        }                                                   
    } catch (error) {
        console.error("Error while changing the page index", error);
    }
    
}
function* previewDrawing() {
    try{
        yield put({type:ActionTypes.ENABLE_LAYERING,data:false});
        yield put((resetZoom()));
        const zoom = window.screen.availWidth/window.innerWidth;
        if(zoom < 0.95) {
            yield put({
                type:ActionTypes.GET_PROJECT_FAILURE, 
                data:{error: `To export good resolution PDF, please reset your browser zoom setting to 100% or above.\nCurrent zoom level is ${Math.round(zoom*100)}%. Press CTRL(CMD) +/- to adjust zoom setting.`}
            }); 
            yield put({
                type:ActionTypes.PREVIEW_DRAWING_FAIL,
                error: 'Zoom level not 1'
            })
            return;
        }

        /*TODO:(Shreya) clean the code*/
        const doc =new jsPDF('l', 'mm', 'a4');
        const Pages = yield select(wizardSelector);
        
        const projectData = yield select(project);
        const {roomDetails} = projectData;
        const roomId = Object.keys(roomDetails)[0];
        const { roomName } = roomDetails[roomId];
        const {Client_Id: clientName} = projectData.customer_details;

        let element;
        const previewModeX = yield select(previewModeSelector);
        element = document.getElementById('pageContainer');
        if (element && previewModeX==='enabled') {
            //originalHeight = element.offsetHeight;
            // element.style.height = ((originalHeight - originalHeight*0.08) + "px");
        }
        for (const key in Object.keys(Pages)) {
                if(disconnected){
                    yield put({
                        type:ActionTypes.GET_PROJECT_FAILURE, 
                        data:{error: `Your internet connection is unstable,please refresh & preview 2DD after some time`}
                    });
                    yield put({
                        type:ActionTypes.PREVIEW_DRAWING_FAIL,
                        error:"Preview drawing failed due to internet issue"
                    })
                    throw new Error("Internet unstable");
                }
                const previewMode = yield select(previewModeSelector);
                if(navigator.onLine){
                    let pageObj = Pages[key];
                    if (previewMode && previewMode==='enabled') {
                        if(pageObj && (pageObj.isOptional || pageObj.name.includes("OLD PAGE")))
                            continue;
                        // for each page: setPage details, then maake errorDiv fit into export class by decreasing original page width
                        yield call(getPageDetails,{data:pageObj});
                        yield call(savePageDetails,doc,'pageContainer', Pages[key]);
                    }
                    else {
                        return ;
                    }
                }
                else{
                   break;
                }
            }
            if(!navigator.onLine){
                yield put({
                    type:ActionTypes.GET_PROJECT_FAILURE, 
                    data:{error: `Your internet connection is unstable,please refresh & preview 2DD after some time`}
                });
                yield put({
                    type:ActionTypes.PREVIEW_DRAWING_FAIL,
                    error:"Preview drawing failed due to internet issue"
                })
                throw new Error("Internet unstable");
            }
            doc.setProperties({
                title: `${clientName}-${roomName}-2DD`
            })
        const previewMode = yield select(previewModeSelector);
        if(previewMode && previewMode==='enabled'){
            const pageCount = doc.getNumberOfPages();
            doc.deletePage(pageCount)
            window.open(doc.output('bloburl').toString());
            //element.style.height = ((originalHeight+40) + "px");
        }

        yield put({
            type:ActionTypes.PREVIEW_DRAWING_SUCCESS
        })

    }
    catch(error) {
        yield put({
            type:ActionTypes.PREVIEW_DRAWING_FAIL,
            error
        })
       // throw error
    }
}

function* loadCurve(array) {
    try {
        let canvasLoadArray: any = [];
        let curvArray: any = [];

        // Filtring curve element from canvas list
        const filterItem = array?.objects?.filter((e) => e.id);

        // Removing curve element from canvas list
        canvasLoadArray = { ...array, objects: array?.objects?.filter((e) => !e.id) };

        // Group objects by name
        const groupedObjects = filterItem?.length && filterItem?.reduce((acc, obj) => {
            const { id } = obj;
            if (id !== undefined) {
                if (!acc[id]) {
                    acc[id] = [];
                }
                acc[id].push(obj);
            }
            return acc;
        }, {});        

        if (groupedObjects && Object.keys(groupedObjects)?.length) {

            Object.keys(groupedObjects)?.map((e) => {

                // Fetiching curve element details
                const json = {
                    line: groupedObjects?.[e]?.find((e) => e?.name === 'line'),
                    p0: groupedObjects?.[e]?.find((e) => e?.name === 'p0'),
                    p1: groupedObjects?.[e]?.find((e) => e?.name === 'p1'),
                    p2: groupedObjects?.[e]?.find((e) => e?.name === 'p2'),
                }

                // Checking if all curve element are avaiable.
                if (json?.line && json?.p0 && json?.p1 && json?.p2) {

                    // Pushing curve details in array.
                    curvArray.push(json)
                } else {

                    // If any of the curve element is missing then pushing it to normal element.
                    canvasLoadArray = { ...canvasLoadArray, objects: canvasLoadArray?.objects?.concat(groupedObjects[e]) };
                }
            })
        }

        return { 
            canvasLoadArray,
            curvArray
        }
    }
    catch (e) {
        throw e
    }
}

function* loadFromJSON(json) {
    try {

        const canvas = yield select(fabricInstanceSelector);
        const canvasObj = yield loadCurve(json);

        canvas.loadFromJSON(canvasObj?.canvasLoadArray, canvas.renderAll.bind(canvas), function (o, object) {
            // `o` = json object
            // `object` = fabric.Object instance
            // ... do some stuff ...
        });

        if(canvasObj?.curvArray && canvasObj?.curvArray?.length){
            canvasObj?.curvArray?.map((e) => {
                dynamic_curve(canvas, e);
            })
        }
    }
    catch (e) {
        throw e

    }


}

function* setDrawingObject(action){
    try {
        const canvas = yield select(fabricInstanceSelector);
        const pageDetails = yield select(pageDetailsSelector);
        //const scaleFactor = yield select(scaleFactorSelector);
        const screenSize = pageDetails?.drawing?.screenSize;
        // const screenSize = yield select(screenSizeSelector);
        const currentWidth =window.screen.width;
        const currentHeight =window.screen.height;
        const drawingObject = pageDetails?.drawing?.drawingData || {};
        // const drawingObject = yield select(drawingObjectSelector);
        if(Object.keys(canvas).length!==0){
            // @ts-ignore
            canvas.clear();
            let SCALE_FACTOR_X,SCALE_FACTOR_Y;
            // const SCALE_FACTOR =(currentHeight*currentWidth)/(screenSize.screenHeight*screenSize.screenWidth)
            if(screenSize){
                SCALE_FACTOR_X =(currentWidth)/(screenSize.screenWidth)
                 SCALE_FACTOR_Y =(currentHeight)/(screenSize.screenHeight)
                // if(SCALE_FACTOR_X===1 && scaleFactor) SCALE_FACTOR_X=scaleFactor?.ScaleX
                // if(SCALE_FACTOR_Y===1 && scaleFactor) SCALE_FACTOR_Y=scaleFactor?.ScaleY
            }
            else{
                SCALE_FACTOR_X =1;
                SCALE_FACTOR_Y =1;
            }
            //
            // canvas.loadFromJSON(drawingObject, canvas.renderAll.bind(canvas), function(o, object) {
            //
            // });
            yield loadFromJSON(drawingObject)
            console.log("*******************8")
            console.log(SCALE_FACTOR_X)
            console.log(SCALE_FACTOR_Y)
            console.log(drawingObject)
            console.log("*******************8")
            /*Scaling fabric objects according to screen size*/
            const objects = canvas.getObjects();
            for (const i in objects) {
                const scaleX = objects[i].scaleX;
                const scaleY = objects[i].scaleY;
                //const left = objects[i].left;
                //const top = objects[i].top;

                const tempScaleX = scaleX * ( SCALE_FACTOR_X);
                const tempScaleY = scaleY * ( SCALE_FACTOR_Y);
                //const tempLeft = left * ( SCALE_FACTOR_X);
                //const tempTop = top * ( SCALE_FACTOR_Y);

                objects[i].scaleX = tempScaleX;
                objects[i].scaleY = tempScaleY;
                // objects[i].left = tempLeft;
                // objects[i].top = tempTop;

                objects[i].setCoords();
            }

            canvas.renderAll();
            yield put({
                type:ActionTypes.SET_DRAWING_DATA_SUCCESS,
                data:{
                    ScaleX:SCALE_FACTOR_X,
                    ScaleY:SCALE_FACTOR_Y
                }
            })
        }

    }
    catch(error) {
        yield put({
            type:ActionTypes.SET_DRAWING_DATA_FAIL,
        })
        throw error

    }
}

function* setNotes({data}){
    try {
        const {notes} = data;
        const projectDetails = yield select(project);
        const {opportunityId, version, roomDetails} = projectDetails;
        const projectId = `${opportunityId}_${version}`, roomId=Object.keys(roomDetails)[0];
        const pageData = yield select(pageDetails);
        pageData['notes'] = notes;
        let payload ={};
        payload[pageData['pageNumber']] = pageData;
        const updatePage = yield fetchDrawingApi(`pages/project/${projectId}/room/${roomId}`,{
            method: "PUT",
            body: JSON.stringify(payload),
            headers:{
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              }
        });
        const newPageData = yield updatePage.json();
        if(newPageData && !newPageData.error){
            yield put((setPageDetails(pageData)));
        }
    } catch (error) {
        console.error("Error in setNotes", error);
    }
}

function* createPageCopy({data}){
    try {
        
        const {pageNumber, pageData} = data;
        let payload = {};
        pageData['pageType'] = 'created_page';
        pageData['pageNumber'] = pageNumber;
        payload[pageNumber] = pageData;
        const projectData = yield select(project);
        const {opportunityId, version,roomDetails} =projectData
        const projectId = `${opportunityId}_${version}`, roomId = Object.keys(roomDetails)[0];
        let pages = projectData['roomDetails'][roomId]['pages'];
        pages[pageNumber]= pageData;
        projectData['roomDetails'][roomId]['pages'] = Object.assign({}, pages);
        yield put({type:ActionTypes.GET_PROJECT_SUCCESS, data:projectData});
        const updatePage = yield fetchDrawingApi(`pages/project/${projectId}/room/${roomId}`,{
            method: "PUT",
            body: JSON.stringify(payload),
            headers:{
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              }
        });
        const newPageData = yield updatePage.json();
        if(newPageData && !newPageData.error){
            yield put((getPages({projectId, roomId})))  
        }
            
    } catch (error) {
        
    }
}

function* deletePage({data}){
    try {
        if(!data)
            return;
        const projectData = yield select(project);
        const floorsData = yield select(floorsDataSelector);
        const {opportunityId, version,roomDetails} =projectData
        const projectId = `${opportunityId}_${version}`, roomId = Object.keys(roomDetails)[0];
        let pages = projectData['roomDetails'][roomId]['pages'];
        let pageValues = Object.values(pages), newPages={};
        pageValues.splice(data ===1 ? 0: parseInt(data)-1, 1);
        pageValues.map((page, index)=>{
            page['pageNumber'] = index+1;
            newPages[index+1] = page;
            return page;
        });
        projectData['roomDetails'][roomId]['pages'] = Object.assign({}, newPages);
        yield put({type:ActionTypes.GET_PROJECT_SUCCESS, data:projectData});
        const updatePage = yield fetchDrawingApi(`pages/project/${projectId}/room/${roomId}/page/${data}`,{
            method: "DELETE",
            headers:{
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              }
        });
        const newPageData = yield updatePage.json();
        if(newPageData && !newPageData.error){
            yield put((getPages({projectId, roomId})))
           // yield put((setPageData({pageNumber:data-1, projectData }))) 
            yield put((getPlanOverViewData({roomId,projectData,floorsData})))
        }
            
    } catch (error) {
        
    }
}

/**
 * 
 * Function to upload the images to SC
 */
function* uploadImages({data}){
    try {
        let { images, tag } = data;
        const projectData = yield select(project);
        const {opportunityId,roomDetails} =projectData;
        const roomId = Object.keys(roomDetails)[0]
        var fd = new FormData();
        yield put({type:ActionTypes.UPLOADING_IMAGES, data: true});
        for(var i=0; i< images.length; i++){
            let img = images[i];
            fd.append('images', img);
        }
        
        const uploadImages = yield fetch(`${getSpacecraftDrawingUrl()}projects/${opportunityId}/rooms/${roomId}/tag/${tag}`,{
            method: "POST",
            body: fd,
            headers:{
                "Authorization": yield select(accessToken)
              }
        });
        if(uploadImages && uploadImages.status === 500){
            yield put({type:ActionTypes.GET_PROJECT_FAILURE, data:{error: `Sorry!! Server error while uploading images`}});
            return;
        }
        let imageUrls = yield uploadImages.json();
        if(!imageUrls){
            yield put({type:ActionTypes.GET_PROJECT_FAILURE, data:{error: `Sorry!! Unable to upload images`}});
            return;
        }
        yield put((getImagesBasedOnTag({tag})))
        yield put(imageData(imageUrls[0].imageUrl));
    } catch (error) {
        console.error("Error while uploading image", error);
        yield put({type:ActionTypes.GET_PROJECT_FAILURE, data:{error: `Sorry!! Unable to upload images`}});  
    }
}
/**
 * 
 * Function to delete Images
 */
function* removeImage({data}){
    try {
        let {imageId, tag} = data;
        const projectData = yield select(project);
        const {opportunityId,roomDetails} =projectData;
        const roomId = Object.keys(roomDetails)[0]
        yield fetch(`${getSpacecraftDrawingUrl()}projects/${opportunityId}/rooms/${roomId}/image/${imageId}`,{
            method: "DELETE",
            headers:{
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "Authorization": yield select(accessToken)
              }
        });
        //let deleteImagesResp = yield deleteImages.json();
        // if(!deleteImagesResp){
        //     yield put({type:ActionTypes.GET_PROJECT_FAILURE, data:{error: `Sorry!! Unable to upload images`}});
        //     return;
        // }
        yield put((getImagesBasedOnTag({tag})))
    } catch (error) {
        console.error("Error while removing the image", error);
    }
}
/**
 * 
 * Function to copy selected drawing tool node
 */
 function* copySelectedDrawing(){
    try {
        // clone what are you copying since you
        // may want copy and paste on different moment.
        // and you do not want the changes happened
        // later to reflect on the copy.
        const canvas = yield select(fabricInstanceSelector);
        canvas.getActiveObject().clone(function(cloned) {
            _clipboard.push(cloned);
        });
    } catch (error) {
        console.error("Error while copying the drawing", error);
    }
}
/**
 * 
 * Function to paste copied drawing tool node
 */
 function* pasteSelectedDrawing(){
    try {
        // clone again, so you can do multiple copies.
        const canvas = yield select(fabricInstanceSelector);
	    _clipboard?.map((obj=> {
            let clonedObj = fabric.util.object.clone(obj);
            clonedObj.set('left',obj.left+10);
            clonedObj.set('top',obj.top+10);
            canvas.add(clonedObj);
        }))
        //canvas.setActiveObject(clonedObj);
        canvas.requestRenderAll();
        _clipboard=[];
        yield put({type:ActionTypes.SELECTED_OBJECT,data:[]});
    } catch (error) {
        console.error("Error while pasting the drawing", error);
    }
}

function* handleUploadDqcData(obj){
    try{
     const {data} = obj;
     const projectData = yield select(project);
     const {opportunityId,customer_details} =projectData;
     let dqcData = yield fetch(`${getSpacecraftDrawingUrl()}projects/${opportunityId}/dqcdata`,{
         method: "POST",
         body: JSON.stringify(data),
         headers:{
             'Accept': 'application/json',
             'Content-Type': 'application/json'
           }
     });
     let dqcData_json = yield dqcData.json();
     customer_details["DQC_Manager"] = {
         emailId:dqcData_json.emailId,
         name:dqcData_json.name
     };
     yield put({type:ActionTypes.DQC_DETAILS,data:{isDqcDataPresent:true,dqcUpdateMode:false}});
     yield put({type:ActionTypes.SET_CUSTOMER_DETAILS,data:customer_details});
     yield put({type:ActionTypes.EXPORT_DRAWING,data:projectData});
     }
     catch(e){
         console.log("Error While Uploading DQC Data",e);
     }
 }
 
 function* handleUpdateDqcData(obj){
     try{
     const {data} = obj;
     const projectData = yield select(project);
     const {opportunityId,customer_details} =projectData;
     let isDqc=yield select(isDqcDataPresent);
     let dqcData;
     if(isDqc){
        dqcData = yield fetch(`${getSpacecraftDrawingUrl()}projects/${opportunityId}/dqcdata`,{
             method: "PUT",
             body: JSON.stringify(data),
             headers:{
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
               }
         });
     }
     else{
        dqcData= yield fetch(`${getSpacecraftDrawingUrl()}projects/${opportunityId}/dqcdata`,{
             method: "POST",
             body: JSON.stringify(data),
             headers:{
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
               }
         });
 
     }
    
     let dqcData_json = yield dqcData.json();
     customer_details["DQC_Manager"] = {
         emailId:dqcData_json.emailId,
         name:dqcData_json.name
     };
     yield put({type:ActionTypes.DQC_DETAILS,data:{isDqcDataPresent:true,dqcUpdateMode:false}});
     yield put({type:ActionTypes.SET_CUSTOMER_DETAILS,data:customer_details});
     }
     catch(e){
         console.log("Error While Updating DQC Data",e);
     }
 
 }
 
 function* getRoomImages(obj){
     try{
         if(obj.data){
         const projectData = yield select(project);
         const {opportunityId,roomDetails} =projectData;
         const roomId = Object.keys(roomDetails)[0];
         let roomImages = yield fetch(`${getSpacecraftDrawingUrl()}projects/${opportunityId}/rooms/${roomId}/roomImages`);
         roomImages = yield roomImages.json();
         let Images = [];
         roomImages?.perspectiveImageList?.map(imgObj=>{
         if(imgObj?.imageUrl){
             Images.push({name:imgObj?.imageName,url:imgObj?.imageUrl});
         }
         })
         roomImages?.customImages?.map(imgObj => {
             if(imgObj?.imageUrl){
                 Images.push({name:imgObj?.imageName,url:imgObj?.imageUrl});
             }
         });
         roomImages?.manualScreenshots?.map(imgObj=>{
             if(imgObj?.imageUrl){
                 Images.push({name:imgObj?.imageName,url:imgObj?.imageUrl});
             }
         })
         roomImages?.elevationImageDataList?.map(elevationObj => {
            Object.keys(elevationObj)?.map(key => {
                if(elevationObj[key]?.imageData?.imageUrl){
                    Images.push({name:elevationObj[key]?.imageData?.imageName,url: elevationObj[key]?.imageData?.imageUrl})
                }
            })
         })	
         if(roomImages?.roomTopViewImage?.imageUrl){
            Images.push({name: roomImages?.roomTopViewImage?.imageName , url: roomImages?.roomTopViewImage?.imageUrl});
         }
         if(roomImages?.countertopImage?.imageData?.imageUrl){
             Images.push({name:roomImages?.countertopImage?.imageData?.imageName,url:roomImages?.countertopImage?.imageData?.imageUrl});
         }
         if(roomImages?.lightingViewImage?.imageUrl){
             Images.push({name: roomImages?.lightingViewImage?.imageName,url: roomImages?.lightingViewImage?.imageUrl});
         }
         if(roomImages?.roomTopViewDimensionsImage?.imageUrl){
             Images.push({name: roomImages?.roomTopViewDimensionsImage?.imageName , url: roomImages?.roomTopViewDimensionsImage?.imageUrl});
         }
         if(roomImages?.flooringImageData?.imageUrl){
             Images.push({name: roomImages?.flooringImageData?.roomName,url: roomImages?.flooringImageData?.imageUrl});
         }
         if(roomImages?.roomFloorPlanImage?.imageUrl){
             Images.push({name: roomImages?.roomFloorPlanImage?.imageName,url: roomImages?.roomFloorPlanImage?.imageUrl});
         }
         yield put(setRoomImages(Images));
         }
     }
     catch(e){
         console.log("error while fetching room Images",e);
     }
 }
 
// client_credentials grant against the sc-auth-engine — mints a short-lived
// machine-to-machine token, fetched fresh on every call rather than cached,
// since getRosterToken only runs once per project load. Uses the
// sita-frontend-backend-only client (scope sc:backend, audience sc-backend
// only) rather than the broader sita-backend-preprod client, since this
// secret ships in the browser bundle and sc:backend is all getRosterToken
// needs — narrower blast radius if it leaks. Token TTL is 86400s (1 day).
//
// In local dev (`react-scripts start`) this goes through the setupProxy.js
// dev-server proxy at /sc-auth-proxy, since sc-auth-engine's token endpoint
// isn't CORS-enabled for browser origins. That proxy only exists for
// `react-scripts start` — production builds still call
// REACT_APP_SC_AUTH_ENGINE_URL directly, same as before.
function* fetchScAuthEngineToken(){
    const scAuthEngineBase = process.env.NODE_ENV === 'development'
        ? '/sc-auth-proxy/'
        : process.env.REACT_APP_SC_AUTH_ENGINE_URL;
    const body = new URLSearchParams({ grant_type: 'client_credentials', scope: 'sc:backend' });
    const res = yield fetch(`${scAuthEngineBase}oauth2/token`, {
        method: 'POST',
        headers: {
            'Authorization': process.env.REACT_APP_SC_AUTH_ENGINE_BASIC,
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: body.toString(),
    });
    const data = yield res.json();
    return data?.access_token;
}

function* getRosterToken(){
    try{
        const m2mToken = yield call(fetchScAuthEngineToken);
        const tokenDetails = yield fetch(`${process.env.REACT_APP_SPACECRAFT_URL}sso/tokens/v2`,{
            method: "GET",
            headers: {
                'Authorization': `Bearer ${m2mToken}`,
            },
        }).then(res => res.json())


        if(tokenDetails?.roster?.accessToken) {
            localStorage.setItem('roster_token', tokenDetails?.roster?.accessToken);
        }
        if(tokenDetails?.dcRoster?.accessToken) {
            localStorage.setItem('roster_dc_token', tokenDetails?.dcRoster?.accessToken);
        }
    }
    catch(e){
        console.log("error while fetching room Images",e);
    }
}

function* saveUpdatedPageDetails({data, updateRequired}){
    try {
        const projectDetails = yield select(project);
        const {opportunityId, version, roomDetails} = projectDetails;
        const projectId = `${opportunityId}_${version}`, roomId=Object.keys(roomDetails)[0];

        yield put({type:ActionTypes.REQUIRED_META_DATA_UPDATE,data:false});
        
        let payload ={};
        payload[data['pageNumber']] = data;
        const updatePage = yield fetchDrawingApi(`pages/project/${projectId}/room/${roomId}`,{
            method: "PUT",
            body: JSON.stringify(payload),
            headers:{
                'Accept': 'application/json',
                'Content-Type': 'application/json'
                }
        });
        const newPageData = yield updatePage.json();
        
        if(newPageData && !newPageData.error && updateRequired){
            yield put((setPageDetails(data)));
        }
    } catch (error) {
        console.error("Error in setNotes", error);
    }
}

function* pagewiseDocument(pageList: any, roomName: any) {
    try {
        let uploadDrawingFiles;
        categoriesS3Url = {}

        if (Object.keys(pageList)?.length && pageList) {

            uploadDrawingFiles = yield all(Object.entries(pageList).map((doc: any) => {
                const pageCount = doc[1].getNumberOfPages();
                doc[1].deletePage(pageCount);

                doc[1].setProperties({
                    title: `${roomName} ${doc[0].replace(/_/g, ' ')}-2DD`,
                });
                const pdf = new File([doc[1].output("blob")], `${doc[0].replace(/_/g, ' ')}-2DD.pdf`, { type: "application/pdf" });
                const data = new FormData();
                data.append("pdf", pdf);

                return call(uploadDrawing, { data, doc:doc[1], categoriesWise: doc[0].replace(/_/g, ' ') })
            }));

             yield call(updateCategoryWise2DDUrl);
            
        }
    }
    catch (error) {
        console.error("Error in Page wise document", error);
    }
}

// Function to crop the image
function* cropSelectedImage(){
    // const { selectedCropImageDetails, fabricInstance } = this.props
    const canvas = yield select(fabricInstanceSelector);
    const selectedCropImageDetails = yield select(selectedCropImageDetailsSelector)

    // Assigning variables
    var clipRect = selectedCropImageDetails?.selection;
    var newObject = selectedCropImageDetails?.mainImage;
    var object = selectedCropImageDetails?.mainImage;



    var clipX = (clipRect.left - object.left);
    var clipY = (clipRect.top - object.top);
    var clipWidth = clipRect.width * 1 / object.scaleX;
    var clipHeight = clipRect.height * 1 / object.scaleY;

    clipX *= 1 / object.scaleX;
    clipY *= 1 / object.scaleY;

    // Clip the image
    const clipPath = new fabric.Rect({
        // left: (-object.width / 2) + clipX,
        // top: -object.height / 2 + clipY,
        left:  clipX,
        top: clipY,
        width: clipWidth,
        height: clipHeight,
        originX: 'center',
        originY: 'center'
    });

    newObject.set({
        clipPath: clipPath,
        clipPathAbsolute: true
    });


    // Hide selection rectangle
    canvas.remove(object);
    canvas.remove(clipRect);
    canvas.add(newObject);

    console.log('clipRect', clipRect, newObject);

    // Render canvas
    canvas.renderAll();
    yield put((saveCropSelectionDetails('')));
}

function* updateCategoryWise2DDUrl() {
    try{
        const projectData = yield select(project);
        const {opportunityId,roomDetails} =projectData
        const projectId = `${opportunityId}`, roomId = Object.keys(roomDetails)[0];

            const url = `${getSpacecraftDrawingUrl()}projects/${opportunityId}/room/${roomId}/updateCategoryWise2DDUrl`
            yield fetch(url,{
                method: "POST",
                body: JSON.stringify(categoriesS3Url),
                headers:{
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                  }
            });
    }
    catch(e) {
        console.error('Error to update category wise 2DD', e)
    }

}

function* fetchWithRetry(url, options, retries = 2, delayTime = 1000) {
    let attempt = 0;
    while (attempt < retries) {
        try {
            const response = yield fetch(url, options);
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            
            return response; // Return the response data if successful
        } catch (error) {
            const statusCode = error?.message?.includes('Status')
                ? parseInt(error?.message?.split('Status: ')[1])
                : null;
            attempt++;

            if (attempt >= retries || ![500, 502, 503, 504, 408, 429].includes(statusCode)) {
                throw error; // Max retries reached or non-retryable error, throw the error
            }

            // Optionally delay before retrying
            yield delay(delayTime);
        }
    }
}

function* fetchDrawingApiWithRetry(path, options: any = {}, retries = 2, delayTime = 1000){
    let token = yield select(accessToken);
    if(!token){
        showSnackbar(SESSION_EXPIRED_MESSAGE, 5000);
    }
    let headers = Object.assign({}, options.headers, { "Authorization": `Bearer ${token}` });
    try{
        return yield fetchWithRetry(`${process.env.REACT_APP_DRAWING_API_URL}${path}`, Object.assign({}, options, { headers }), retries, delayTime);
    } catch(error){
        if((error as any)?.message?.includes('Status: 401')){
            showSnackbar(SESSION_EXPIRED_MESSAGE, 5000);
        }
        throw error;
    }
}

 export default function* root() {
     yield takeEvery(ActionTypes.SAVE_DRAWING, saveDrawing);
     yield takeEvery(ActionTypes.EXPORT_DRAWING, exportDrawing);
     yield takeEvery(ActionTypes.REVIEW_PAGE, savePageOnReview);
     yield takeLatest(ActionTypes.GET_PAGES, getPagesList);
     yield takeEvery(ActionTypes.SET_PAGE_DATA, getPageDetails);
     yield takeEvery(ActionTypes.PREVIEW_DRAWING, previewDrawing);
     yield takeEvery(ActionTypes.CREATE_NEW_PAGE, handleNewPageCreate);
     yield takeEvery(ActionTypes.HANDLE_DROP, handlePageIndexChange);
     yield takeEvery(ActionTypes.GET_PROJECT, getProjectDetails);
     yield takeEvery(ActionTypes.GET_PLAN_OVERVIEW, getPlanOverView);
     yield takeEvery(ActionTypes.SET_DRAWING_DATA, setDrawingObject);
     yield takeEvery(ActionTypes.SET_PAGE_NOTES, setNotes);
     yield takeEvery(ActionTypes.EXPORT_FINAL_PDF, exportPdf);
     yield takeEvery(ActionTypes.CREATE_PAGE_COPY, createPageCopy);
     yield takeEvery(ActionTypes.UPLOAD_DRAWING, uploadDrawing);
     yield takeEvery(ActionTypes.REMOVE_PAGE, deletePage);
     yield takeEvery(ActionTypes.UPLOAD_IMAGE, uploadImages);
     yield takeEvery(ActionTypes.REMOVE_IMAGE, removeImage);
     yield takeEvery(ActionTypes.GET_TAG_IMAGES, getTagImages);
     yield takeEvery(ActionTypes.COPY_SELECTED_DRAWING, copySelectedDrawing);
     yield takeEvery(ActionTypes.PASTE_SELECTED_DRAWING, pasteSelectedDrawing);
     yield takeEvery(ActionTypes.UPLOAD_DQC_DATA,handleUploadDqcData);
     yield takeEvery(ActionTypes.UPDATE_DQC_DATA,handleUpdateDqcData);
     yield takeEvery(ActionTypes.OPEN_GALLERY,getRoomImages);
     yield takeEvery(ActionTypes.GET_ROSTER_TOKEN,getRosterToken);
     yield takeEvery(ActionTypes.SAVE_UPDATED_PAGE_DETAILS,saveUpdatedPageDetails);
     yield takeEvery(ActionTypes.CROP_SELECTED_IMAGE,cropSelectedImage);
}                